(function () {
  const IS_WISHLIST_ROUTE = window.location.pathname.replace(/\/+$/, '') === '/apps/wishlist';
  if (!IS_WISHLIST_ROUTE || window.WM_WISHLIST_GRID_INSTALLED) return;
  window.WM_WISHLIST_GRID_INSTALLED = true;

  document.documentElement.classList.add('wm-wishlist-auth-pending');
  if (!document.getElementById('wmWishlistAuthPendingStyles')) {
    const style = document.createElement('style');
    style.id = 'wmWishlistAuthPendingStyles';
    style.textContent = 'html.wm-wishlist-auth-pending body{visibility:hidden!important;}';
    document.head.appendChild(style);
  }

  const GRID_CLASS = 'wm-wishlist-grid-view';
  const GRID_READY_CLASS = 'wm-wishlist-grid-ready';
  const TILE_VIEW = 'wm-rec-grid-tile';
  const MOBILE_COLS = '2';
  const DESKTOP_COLS = '4';
  const PAGE_SIZE = 48;
  const productJsonCache = new Map();
  const preorderReleaseDateCache = new Map();
  let collectionIndexPromise = null;
  let cartButtonAlignTimer = null;

  function wishlistScrollUrl() {
    try {
      const referrer = new URL(document.referrer || '', window.location.origin);
      if (referrer.origin === window.location.origin && referrer.pathname.replace(/\/+$/, '') !== '/apps/wishlist') {
        return referrer.pathname + referrer.search;
      }
    } catch (err) {}
    return '/collections/all-records?wm_feed_source=wishlist';
  }

  function waitFor(predicate, timeoutMs = 8000, intervalMs = 120) {
    const startedAt = Date.now();
    return new Promise((resolve) => {
      (function check() {
        const value = predicate();
        if (value) {
          resolve(value);
          return;
        }
        if (Date.now() - startedAt >= timeoutMs) {
          resolve(null);
          return;
        }
        setTimeout(check, intervalMs);
      })();
    });
  }

  function wishlistApi() {
    return window.WishlistKing?._apis?.wishlist || null;
  }

  function wmWishlistCustomerLooksLoggedIn() {
    if (window.WM_CUSTOMER_LOGGED_IN === true) return true;
    if (window.WM_CUSTOMER_AUTH_STATUS && window.WM_CUSTOMER_AUTH_STATUS.authenticated === true) return true;
    if (window.WM_CUSTOMER_AUTH_STATUS && window.WM_CUSTOMER_AUTH_STATUS.authenticated === false) return false;
    return false;
  }

  async function wmWishlistCustomerIsAuthenticated() {
    if (wmWishlistCustomerLooksLoggedIn()) return true;

    if (window.WM_CUSTOMER_AUTH_READY && typeof window.WM_CUSTOMER_AUTH_READY.then === 'function') {
      try {
        const status = await window.WM_CUSTOMER_AUTH_READY;
        if (status && status.authenticated === true) {
          window.WM_CUSTOMER_LOGGED_IN = true;
          try { sessionStorage.setItem('wm_customer_auth_confirmed', '1'); } catch (err) {}
          return true;
        }
        if (status && status.authenticated === false) {
          window.WM_CUSTOMER_LOGGED_IN = false;
          try { sessionStorage.removeItem('wm_customer_auth_confirmed'); } catch (err) {}
          return false;
        }
      } catch (err) {}
    }

    try {
      const controller = typeof AbortController !== 'undefined' ? new AbortController() : null;
      const timeout = controller ? setTimeout(() => controller.abort(), 3500) : null;
      const res = await fetch('/apps/wm-recommendations/session', {
        method: 'POST',
        cache: 'no-store',
        credentials: 'same-origin',
        signal: controller ? controller.signal : undefined,
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify({})
      });
      if (timeout) clearTimeout(timeout);
      if (!res.ok) return wmWishlistCustomerLooksLoggedIn();

      const status = await res.json();
      window.WM_CUSTOMER_AUTH_STATUS = status;
      if (status && status.authenticated === true) {
        window.WM_CUSTOMER_LOGGED_IN = true;
        try { sessionStorage.setItem('wm_customer_auth_confirmed', '1'); } catch (err) {}
        return true;
      }

      try { sessionStorage.removeItem('wm_customer_auth_confirmed'); } catch (err) {}
      return false;
    } catch (err) {
      return wmWishlistCustomerLooksLoggedIn();
    }
  }

  function redirectToWishlistLogin() {
    const returnTo = encodeURIComponent(window.location.pathname + window.location.search);
    window.location.replace('/customer_authentication/login?return_to=' + returnTo);
  }

  function normalizeGid(value) {
    return String(value || '').replace(/^gid:\/\/shopify\/(?:Product|ProductVariant)\//, '');
  }

  function wishlistItemHandle(item) {
    const candidates = [
      item?.product?.handle,
      item?.handle,
      item?.product_handle,
      item?.productHandle,
      item?.product?.product_handle
    ];

    for (const candidate of candidates) {
      const value = String(candidate || '').trim();
      if (value) return value;
    }

    const url = String(item?.product?.url || item?.url || item?.product_url || '').trim();
    const match = url.match(/\/products\/([^/?#]+)/);
    return match ? decodeURIComponent(match[1]) : '';
  }

  function wishlistItemKey(item) {
    return [
      wishlistItemHandle(item),
      normalizeGid(item?.variant_id || item?.variantId || item?.variant?.id),
      normalizeGid(item?.product_id || item?.productId || item?.product?.id)
    ].filter(Boolean).join(':');
  }

  function wishlistItemId(item) {
    return String(item?.id || item?.wishlist_item_id || item?.wishlistItemId || '').trim();
  }

  function wishlistVariantId(item) {
    return normalizeGid(item?.variant_id || item?.variantId || item?.variant?.id || item?.selected_variant_id || item?.product?.selected_variant_id);
  }

  function parseSortDate(value) {
    const time = Date.parse(String(value || ''));
    return Number.isFinite(time) ? time : 0;
  }

  function itemTitle(item, product) {
    return String(
      product?.title ||
      item?.product?.title ||
      item?.title ||
      ''
    ).replace(/\s+/g, ' ').trim().toLowerCase();
  }

  function itemPrice(item, product) {
    const value =
      product?.price ??
      product?.variants?.[0]?.price ??
      item?.price ??
      item?.product?.price ??
      item?.variant?.price ??
      0;
    const number = Number(String(value).replace(/[^0-9.]/g, ''));
    return Number.isFinite(number) ? number : 0;
  }

  function itemCreatedTime(item, product) {
    return parseSortDate(
      product?.created_at ||
      product?.published_at ||
      item?.product?.created_at ||
      item?.product?.published_at ||
      item?.created_at ||
      item?.createdAt ||
      item?.added_at ||
      item?.addedAt
    );
  }

  function itemReleaseTime(item, product) {
    const direct = parseSortDate(
      item?.release_date ||
      item?.releaseDate ||
      item?.product?.release_date ||
      item?.product?.releaseDate ||
      product?.release_date ||
      product?.releaseDate
    );
    if (direct) return direct;

    const tags = Array.isArray(product?.tags) ? product.tags : [];
    for (const tag of tags) {
      const match = String(tag || '').match(/(?:release[_ -]?date|released)[:_ -]+(\d{4}[-/]\d{1,2}[-/]\d{1,2})/i);
      if (match) {
        const time = parseSortDate(match[1].replace(/\//g, '-'));
        if (time) return time;
      }
    }
    return itemCreatedTime(item, product);
  }

  async function productJson(handle) {
    if (!handle) return null;
    if (productJsonCache.has(handle)) return productJsonCache.get(handle);
    const promise = fetch(`/products/${encodeURIComponent(handle)}.js`, {
      headers: { 'Accept': 'application/json' }
    }).then((response) => {
      if (!response.ok) throw new Error(`Product JSON failed for ${handle}: ${response.status}`);
      return response.json();
    });
    productJsonCache.set(handle, promise);
    return promise;
  }

  async function collectionIndexItems() {
    if (collectionIndexPromise) return collectionIndexPromise;
    collectionIndexPromise = (async () => {
      const all = [];
      let page = 1;
      while (true) {
        const url = new URL('/collections/all-records', window.location.origin);
        url.searchParams.set('view', 'wm-index');
        url.searchParams.set('page', String(page));
        url.searchParams.set('_wm_wishlist_grid_index_v', String(Date.now()));
        const response = await fetch(url.toString(), {
          cache: 'no-store',
          headers: { 'X-Requested-With': 'XMLHttpRequest' }
        });
        if (!response.ok) break;
        const chunk = await response.json();
        if (!Array.isArray(chunk) || !chunk.length) break;
        all.push(...chunk);
        if (chunk.length < 250) break;
        page += 1;
      }
      return all;
    })().catch(() => []);
    return collectionIndexPromise;
  }

  async function collectionIndexItem(handle) {
    const normalised = String(handle || '').trim();
    if (!normalised) return null;
    const items = await collectionIndexItems();
    return items.find((item) => String(item?.handle || item?.product_handle || '') === normalised) || null;
  }

  function recommendationUuid() {
    if (window.crypto && typeof window.crypto.randomUUID === 'function') {
      return window.crypto.randomUUID();
    }
    return 'wm-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2);
  }

  function recommendationAnonId() {
    try {
      let id = localStorage.getItem('wm_recommendations_anon_id_v1');
      if (!id) {
        id = recommendationUuid();
        localStorage.setItem('wm_recommendations_anon_id_v1', id);
      }
      return id;
    } catch (err) {
      return recommendationUuid();
    }
  }

  function pushUnique(list, value) {
    const clean = String(value || '').trim();
    if (!clean || list.includes(clean)) return;
    list.push(clean);
  }

  function parseRecommendationTags(tags) {
    const parsed = {
      artists: [],
      labels: [],
      genres: [],
      sub_genres: [],
      mood_style: [],
      other_tags: []
    };
    if (!Array.isArray(tags)) return parsed;

    tags.forEach((tag) => {
      const raw = String(tag || '').trim();
      if (!raw) return;
      const lower = raw.toLowerCase();
      const colonIndex = raw.indexOf(':');
      const prefix = colonIndex >= 0 ? raw.slice(0, colonIndex).trim().toLowerCase() : '';
      const value = colonIndex >= 0 ? raw.slice(colonIndex + 1).trim() : raw;

      if (prefix === 'distributor' || prefix === 'dist' || prefix === 'distributed-by') return;
      if (prefix === 'artist') return pushUnique(parsed.artists, value);
      if (prefix === 'label') return pushUnique(parsed.labels, value);
      if (prefix === 'subgenre' || prefix === 'sub-genre') return pushUnique(parsed.sub_genres, value);
      if (prefix === 'descriptor' || prefix === 'mood' || prefix === 'style') return pushUnique(parsed.mood_style, value);
      if (prefix) return pushUnique(parsed.other_tags, raw);

      if (lower === 'new' || lower === 'preorder') {
        pushUnique(parsed.other_tags, raw);
      } else {
        pushUnique(parsed.genres, raw);
      }
    });

    return parsed;
  }

  async function recommendationPayload(handle) {
    const cleanHandle = String(handle || '').trim();
    if (!cleanHandle) return null;
    const [product, indexItem] = await Promise.all([
      productJson(cleanHandle).catch(() => null),
      collectionIndexItem(cleanHandle).catch(() => null)
    ]);
    const tags = Array.isArray(indexItem?.tags)
      ? indexItem.tags
      : (Array.isArray(product?.tags) ? product.tags : []);
    if (!tags.length) return null;

    const parsedTags = parseRecommendationTags(tags);
    return {
      product_handle: cleanHandle,
      product_id: indexItem?.id || indexItem?.product_id || product?.id || null,
      recommendation: null,
      metadata: {
        artists: Array.isArray(indexItem?.artists) ? indexItem.artists : (indexItem?.artist ? [indexItem.artist] : parsedTags.artists),
        labels: Array.isArray(indexItem?.labels) ? indexItem.labels : (indexItem?.label ? [indexItem.label] : parsedTags.labels),
        genres: indexItem?.genres || parsedTags.genres,
        sub_genres: indexItem?.sub_genres || indexItem?.subGenres || parsedTags.sub_genres,
        mood_style: indexItem?.mood_style || indexItem?.moodStyle || parsedTags.mood_style,
        other_tags: indexItem?.other_tags || indexItem?.otherTags || parsedTags.other_tags,
        raw_tags: tags
      }
    };
  }

  async function postRecommendationEvent(handle, eventType, extra = {}) {
    const payload = await recommendationPayload(handle);
    if (!payload) return;
    const proxyBase = String(window.WM_RECOMMENDATIONS_PROXY_BASE || '/apps/wm-recommendations').replace(/\/+$/, '');
    fetch(proxyBase + '/events', {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({
        anonymous_id: recommendationAnonId(),
        occurred_at: new Date().toISOString(),
        source: 'wishlist_grid',
        event_type: eventType,
        ...extra,
        ...payload
      }),
      keepalive: true
    }).catch(() => {});
  }

  function productIsPreorder(product, indexItem) {
    const productTags = Array.isArray(product?.tags) ? product.tags : String(product?.tags || '').split(',');
    const indexTags = Array.isArray(indexItem?.tags) ? indexItem.tags : String(indexItem?.tags || '').split(',');
    const tags = []
      .concat(productTags)
      .concat(indexTags)
      .map((tag) => String(tag || '').toLowerCase());
    const variants = Array.isArray(product?.variants) ? product.variants : [];
    return (
      indexItem?.is_preorder === true ||
      tags.includes('preorder') ||
      variants.some((variant) => {
        const policy = String(variant?.inventory_policy || '').toLowerCase();
        const quantity = Number(variant?.inventory_quantity ?? variant?.inventoryQuantity ?? 0);
        return policy === 'continue' && quantity <= 0;
      })
    );
  }

  function preorderReleaseDate(item, product, indexItem) {
    return String(
      indexItem?.preorder_release_date ||
      item?.preorder_release_date ||
      item?.preorderReleaseDate ||
      item?.product?.preorder_release_date ||
      item?.product?.preorderReleaseDate ||
      product?.preorder_release_date ||
      product?.preorderReleaseDate ||
      ''
    ).trim();
  }

  async function resolvePreorderReleaseDate(handle, button) {
    const existing = String(button?.dataset?.wmPreorderReleaseDate || '').trim();
    if (existing) return existing;
    if (!handle) return '';
    if (preorderReleaseDateCache.has(handle)) {
      const cached = await preorderReleaseDateCache.get(handle);
      if (cached && button) button.dataset.wmPreorderReleaseDate = cached;
      return cached;
    }

    const promise = (async () => {
      const productUrl = `/products/${encodeURIComponent(handle)}`;
      const urls = [`${productUrl}?view=ajax-card`, productUrl];
      for (const url of urls) {
        try {
          const response = await fetch(url, {
            cache: 'no-store',
            headers: { 'X-Requested-With': 'XMLHttpRequest' }
          });
          if (!response.ok) continue;
          const html = await response.text();
          const doc = new DOMParser().parseFromString(html, 'text/html');
          const input = doc.querySelector('input[name="properties[_wm_release_date]"]');
          const value = String(input?.value || input?.getAttribute('value') || '').trim();
          if (value) return value;
        } catch (err) {}
      }
      return '';
    })();

    preorderReleaseDateCache.set(handle, promise);
    const resolved = await promise;
    if (resolved && button) button.dataset.wmPreorderReleaseDate = resolved;
    return resolved;
  }

  async function resolveCartVariantId(handle, preferredVariantId) {
    const preferred = normalizeGid(preferredVariantId);
    if (preferred) return preferred;
    const product = await productJson(handle);
    const variant = product?.variants?.find((item) => item.available) || product?.variants?.[0];
    return variant?.id ? String(variant.id) : '';
  }

  function wishlistItemAvailable(item, product, indexItem) {
    if (productIsPreorder(product, indexItem)) return true;
    const preferred = wishlistVariantId(item);
    if (product?.variants?.length) {
      if (preferred) {
        const variant = product.variants.find((entry) => String(entry?.id || '') === preferred);
        if (variant) return variant.available !== false;
      }
      return product.variants.some((entry) => entry?.available !== false);
    }
    if (typeof item?.available === 'boolean') return item.available;
    if (typeof item?.product?.available === 'boolean') return item.product.available;
    return true;
  }

  function preorderCartProperties(isPreorder, releaseDate = '') {
    if (!isPreorder) return undefined;
    const properties = { _wm_preorder: 'Yes' };
    const date = String(releaseDate || '').trim();
    if (date) properties._wm_release_date = date;
    return properties;
  }

  async function addVariantToCart(variantId, isPreorder = false, releaseDate = '') {
    if (!variantId) throw new Error('Missing variant ID');
    const response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        items: [{ id: Number(variantId), quantity: 1, properties: preorderCartProperties(isPreorder, releaseDate) }]
      })
    });
    if (!response.ok) throw new Error(`Cart add failed: ${response.status}`);
    return response.json();
  }

  async function addVariantsToCart(variantEntries) {
    const seen = new Set();
    const items = variantEntries
      .map((entry) => {
        if (!entry) return null;
        const rawId = typeof entry === 'object' ? entry.id : entry;
        const id = String(rawId || '').trim();
        if (!id || seen.has(id)) return null;
        seen.add(id);
        return {
          id: Number(id),
          quantity: 1,
          properties: preorderCartProperties(typeof entry === 'object' && entry.isPreorder, typeof entry === 'object' ? entry.releaseDate : '')
        };
      })
      .filter((item) => Number.isFinite(item.id));
    if (!items.length) throw new Error('No variants to add');
    const response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({ items })
    });
    if (!response.ok) throw new Error(`Bulk cart add failed: ${response.status}`);
    return response.json();
  }

  function refreshCartCount() {
    fetch('/cart.js')
      .then((response) => response.json())
      .then((cart) => {
        const count = cart?.item_count;
        const cartIcon = document.querySelector('#CartButton [x-text="$store.cart_count.count"]');
        if (cartIcon && typeof count === 'number') {
          cartIcon.textContent = String(count);
          cartIcon.style.display = count > 0 ? 'flex' : 'none';
          cartIcon.classList.add('cart-updated');
          setTimeout(() => cartIcon.classList.remove('cart-updated'), 800);
        }
        document.dispatchEvent(new CustomEvent('wm:wishlist-cart-added', { detail: { cart } }));
      })
      .catch(() => {});
  }

  async function loadWishlistItems() {
    const api = wishlistApi();
    if (!api?.loadWishlist) return [];
    const result = await api.loadWishlist({ wishlistId: 'mine' });
    return (
      result?.wishlist?.items ||
      result?.items ||
      result?.products ||
      []
    );
  }

  function buildShell(defaultPage) {
    let shell = document.getElementById('wmWishlistGrid');
    if (shell) return shell;

    shell = document.createElement('section');
    shell.id = 'wmWishlistGrid';
    shell.className = 'wm-wishlist-grid';
    shell.setAttribute('aria-label', 'Wishlist');
    const scrollUrl = wishlistScrollUrl();
    shell.innerHTML = `
      <div class="wm-wishlist-grid__inner">
        <header class="wm-wishlist-grid__header" aria-label="Wishlist controls">
          <div class="wm-wishlist-feed-toolbar">
            <button type="button" class="wm-wishlist-grid__bulk" data-wm-wishlist-add-all hidden>ADD ALL TO CART</button>
            <select class="wm-wishlist-grid__sort wm-grid-toolbar__select" data-wm-wishlist-sort aria-label="Sort wishlist">
              <option value="wm-random">SHUFFLE</option>
              <option value="best-selling">BESTSELLERS</option>
              <option value="created-descending" selected>NEWEST</option>
              <option value="created-ascending">OLDEST</option>
              <option value="release-date-desc">RELEASE DATE ↓</option>
              <option value="release-date-asc">RELEASE DATE ↑</option>
              <option value="price-ascending">PRICE ↑</option>
              <option value="price-descending">PRICE ↓</option>
              <option value="title-ascending">A-Z</option>
              <option value="title-descending">Z-A</option>
            </select>
            <a class="wm-wishlist-grid__view-toggle" href="${scrollUrl}" data-wm-wishlist-scroll-view aria-label="Switch to scroll feed" title="Scroll feed">
              <svg class="wm-grid-view-icon wm-grid-view-icon--filled" viewBox="0 0 24 24" width="23" height="23" aria-hidden="true" focusable="false" fill="none">
                <rect x="4.05" y="4.05" width="6.95" height="6.95" rx="1.3" fill="currentColor"/>
                <rect x="13" y="4.05" width="6.95" height="6.95" rx="1.3" fill="currentColor"/>
                <rect x="4.05" y="13" width="6.95" height="6.95" rx="1.3" fill="currentColor"/>
                <rect x="13" y="13" width="6.95" height="6.95" rx="1.3" fill="currentColor"/>
              </svg>
            </a>
          </div>
        </header>
        <div class="wm-wishlist-grid__status" data-wm-wishlist-status>
          <div class="wm-feed-loading" aria-label="Loading"><div class="spinner"></div></div>
        </div>
        <ul class="wm-wishlist-grid__items grid gap-theme grid-cols-2 lg:grid-cols-4" data-wm-wishlist-list hidden></ul>
        <div class="wm-wishlist-grid__sentinel" data-wm-wishlist-sentinel hidden aria-hidden="true"></div>
        <div class="wm-wishlist-grid__more-wrap" data-wm-wishlist-more-wrap hidden>
          <button type="button" class="wm-wishlist-grid__more" data-wm-wishlist-more>Load more</button>
        </div>
      </div>
    `;

    const insertionTarget = defaultPage?.closest('.shopify-block') || defaultPage;
    if (insertionTarget?.parentNode) {
      insertionTarget.parentNode.insertBefore(shell, insertionTarget);
    } else {
      (document.querySelector('main') || document.body).appendChild(shell);
    }

    const addAllButton = shell.querySelector('[data-wm-wishlist-add-all]');
    const sortSelect = shell.querySelector('[data-wm-wishlist-sort]');
    addAllButton.hidden = false;
    addAllButton?.addEventListener('click', () => addVisibleWishlistToCart(shell, addAllButton));
    sortSelect?.addEventListener('change', () => sortWishlistGrid(shell, sortSelect.value));
    installWishlistSelects(shell);

    return shell;
  }

  async function addVisibleWishlistToCart(shell, button) {
    if (!shell || !button || button.disabled) return;
    const originalText = button.textContent;
    let targets = Array.isArray(shell.__wmWishlistItems) ? shell.__wmWishlistItems.map((item) => ({
      handle: wishlistItemHandle(item),
      variantId: wishlistVariantId(item)
    })).filter((item) => item.handle) : [];

    if (!targets.length) {
      targets = Array.from(shell.querySelectorAll('.wm-wishlist-owned-tile[data-wm-wishlist-handle]'))
        .filter((tile) => !tile.classList.contains('is-wishlist-removing') && tile.isConnected)
        .map((tile) => ({
          handle: tile.dataset.wmWishlistHandle || '',
          variantId: tile.dataset.wmWishlistVariantId || ''
        }))
        .filter((item) => item.handle);
    }

    button.disabled = true;
    button.textContent = 'ADDING...';
    try {
      const availableTargets = await Promise.all(targets.map(async (item) => {
        const [product, indexItem] = await Promise.all([
          productJson(item.handle).catch(() => null),
          collectionIndexItem(item.handle).catch(() => null)
        ]);
        return wishlistItemAvailable({ variant_id: item.variantId }, product, indexItem)
          ? { ...item, isPreorder: productIsPreorder(product, indexItem), releaseDate: preorderReleaseDate(item, product, indexItem) }
          : null;
      }));
      const variantIds = await Promise.all(availableTargets.filter(Boolean).map((item) => {
        return resolveCartVariantId(item.handle, item.variantId)
          .then(async (id) => ({
            id,
            isPreorder: item.isPreorder,
            releaseDate: item.releaseDate || (item.isPreorder ? await resolvePreorderReleaseDate(item.handle) : '')
          }))
          .catch(() => null);
      }));
      await addVariantsToCart(variantIds);
      targets.forEach((item) => postRecommendationEvent(item.handle, 'add_to_cart'));
      refreshCartCount();
      button.textContent = 'ADDED';
      setTimeout(() => {
        button.disabled = false;
        button.textContent = originalText || 'ADD ALL TO CART';
      }, 1800);
    } catch (err) {
      button.textContent = 'TRY AGAIN';
      setTimeout(() => {
        button.disabled = false;
        button.textContent = originalText || 'ADD ALL TO CART';
      }, 1800);
    }
  }

  async function fetchGridTile(handle, index) {
    const params = new URLSearchParams({
      view: TILE_VIEW,
      i: String(index),
      mobile_cols: MOBILE_COLS,
      desktop_cols: DESKTOP_COLS,
      display_on_card: '0',
      quick_buy: '0'
    });
    const response = await fetch(`/products/${encodeURIComponent(handle)}?${params.toString()}`, {
      headers: { 'X-Requested-With': 'XMLHttpRequest' }
    });
    if (!response.ok) throw new Error(`Tile failed for ${handle}: ${response.status}`);
    const html = await response.text();
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const tile = doc.querySelector('.wm-index-grid__item') || doc.body.firstElementChild;
    return tile ? document.importNode(tile, true) : null;
  }

  async function removeWishlistItem(itemId) {
    const api = wishlistApi();
    if (!api?.removeItem || !itemId) return false;
    await api.removeItem({
      wishlistId: 'mine',
      wishlistItemId: itemId
    });
    return true;
  }

  function refreshWishlistButtons() {
    clearTimeout(window.__wmWishlistGridRefreshTimer);
    window.__wmWishlistGridRefreshTimer = setTimeout(() => {
      const refresh = [
        window.WishlistKing?.buttons?.refresh ? () => window.WishlistKing.buttons.refresh() : null,
        window.WishlistKing?.buttons?.render ? () => window.WishlistKing.buttons.render() : null,
        window.WishlistKing?.refresh ? () => window.WishlistKing.refresh() : null,
        window.WishlistKing?.render ? () => window.WishlistKing.render() : null,
        window.WishlistKing?.scan ? () => window.WishlistKing.scan() : null
      ].find(Boolean);
      try {
        const result = refresh?.();
        if (result && typeof result.catch === 'function') result.catch(() => {});
      } catch (err) {}
      setTimeout(() => markWishlistOwnedButtons(document.getElementById('wmWishlistGrid')), 120);
    }, 140);
  }

  function setTileWishlistState(button, isActive) {
    if (!button) return;
    button.classList.toggle('wm-wishlist-owned', !!isActive);
    button.setAttribute('aria-pressed', isActive ? 'true' : 'false');
    button.setAttribute('aria-label', isActive ? 'Remove from wishlist' : 'Add to wishlist');
  }

  function markWishlistOwnedButtons(root) {
    if (!root) return;
    root.querySelectorAll('.wm-grid-swish-anchor .wk-button, .wm-wishlist-remove-button').forEach((button) => {
      if (button.dataset.wmWishlistGridTouched === '1') return;
      setTileWishlistState(button, true);
    });
  }

  function updateWishlistCounter(delta) {
    const counter = document.querySelector('.wk-counter');
    if (!counter) return;
    const current = Number.parseInt(counter.textContent || '0', 10);
    if (Number.isNaN(current)) return;
    counter.textContent = String(Math.max(0, current + delta));
  }

  function addWishlistRemoveButton(tile, item) {
    if (!tile) return;
    const itemId = wishlistItemId(item);
    const handle = wishlistItemHandle(item);
    tile.dataset.wmWishlistItemId = itemId;
    tile.dataset.wmWishlistHandle = handle;
    tile.classList.add('wm-wishlist-owned-tile');
    tile.querySelectorAll('.wm-grid-swish-anchor').forEach((anchor) => {
      anchor.classList.add('wm-wishlist-native-heart-hidden');
      anchor.setAttribute('aria-hidden', 'true');
    });

    const media = tile.querySelector('.product-tile__featured-media') || tile.querySelector('.media') || tile;
    if (media.querySelector('.wm-wishlist-remove-button')) return;
    const button = document.createElement('button');
    button.type = 'button';
    button.className = 'wm-wishlist-remove-button wm-wishlist-owned';
    button.setAttribute('aria-label', 'Remove from wishlist');
    button.setAttribute('aria-pressed', 'true');
    button.dataset.wmWishlistItemId = itemId;
    button.dataset.wmWishlistHandle = handle;
    button.innerHTML = '<span class="visually-hidden">Remove from wishlist</span>';
    media.appendChild(button);
  }

  function addWishlistCartButton(tile, item, product, indexItem) {
    if (!tile) return;
    const handle = wishlistItemHandle(item);
    const variantId = wishlistVariantId(item);
    const isPreorder = productIsPreorder(product, indexItem);
    const releaseDate = preorderReleaseDate(item, product, indexItem);
    const isAvailable = wishlistItemAvailable(item, product, indexItem);
    tile.dataset.wmWishlistVariantId = variantId;

    const details = tile.querySelector('.product-tile.mt-5') || tile.querySelector('.product-tile:not(.wm-grid-audio-card)') || tile;
    details.classList.add('wm-wishlist-details');
    if (details.querySelector('.wm-wishlist-cart-button')) return;
    const button = document.createElement('button');
    button.type = 'button';
    button.className = 'wm-wishlist-cart-button';
    button.dataset.wmWishlistHandle = handle;
    button.dataset.wmWishlistVariantId = variantId;
    if (releaseDate) button.dataset.wmPreorderReleaseDate = releaseDate;
    if (isPreorder) {
      button.classList.add('is-preorder');
      button.dataset.wmCartDefaultText = 'PRE-ORDER';
      button.textContent = 'PRE-ORDER';
    } else if (isAvailable) {
      button.dataset.wmCartDefaultText = 'ADD TO CART';
      button.textContent = 'Add to cart';
    } else {
      button.disabled = true;
      button.classList.add('is-sold-out');
      button.setAttribute('aria-disabled', 'true');
      button.textContent = 'Sold out';
    }
    details.appendChild(button);
  }

  function tileSortText(tile) {
    return String(tile?.querySelector('.wm-wishlist-details h3, h3')?.textContent || '').replace(/\s+/g, ' ').trim().toLowerCase();
  }

  function tileSortPrice(tile) {
    const text = String(tile?.querySelector('.wm-wishlist-details a, .wm-wishlist-details, .product-tile')?.textContent || '');
    const match = text.match(/[£$€]\s*([0-9]+(?:[.,][0-9]+)?)/);
    return match ? Number(match[1].replace(',', '.')) : 0;
  }

  async function sortWishlistItems(items, value) {
    const records = await Promise.all(items.map(async (item, index) => {
      const handle = wishlistItemHandle(item);
      const product = await productJson(handle).catch(() => null);
      return { item, product, index };
    }));

    const sorted = records.slice();
    if (value === 'wm-random') {
      for (let index = sorted.length - 1; index > 0; index -= 1) {
        const swapIndex = Math.floor(Math.random() * (index + 1));
        [sorted[index], sorted[swapIndex]] = [sorted[swapIndex], sorted[index]];
      }
    } else if (value === 'created-descending') {
      sorted.sort((a, b) => itemCreatedTime(b.item, b.product) - itemCreatedTime(a.item, a.product) || a.index - b.index);
    } else if (value === 'created-ascending') {
      sorted.sort((a, b) => itemCreatedTime(a.item, a.product) - itemCreatedTime(b.item, b.product) || a.index - b.index);
    } else if (value === 'release-date-desc') {
      sorted.sort((a, b) => itemReleaseTime(b.item, b.product) - itemReleaseTime(a.item, a.product) || a.index - b.index);
    } else if (value === 'release-date-asc') {
      sorted.sort((a, b) => itemReleaseTime(a.item, a.product) - itemReleaseTime(b.item, b.product) || a.index - b.index);
    } else if (value === 'price-ascending') {
      sorted.sort((a, b) => itemPrice(a.item, a.product) - itemPrice(b.item, b.product) || a.index - b.index);
    } else if (value === 'price-descending') {
      sorted.sort((a, b) => itemPrice(b.item, b.product) - itemPrice(a.item, a.product) || a.index - b.index);
    } else if (value === 'title-ascending') {
      sorted.sort((a, b) => itemTitle(a.item, a.product).localeCompare(itemTitle(b.item, b.product)) || a.index - b.index);
    } else if (value === 'title-descending') {
      sorted.sort((a, b) => itemTitle(b.item, b.product).localeCompare(itemTitle(a.item, a.product)) || a.index - b.index);
    } else {
      sorted.sort((a, b) => a.index - b.index);
    }

    return sorted.map((record) => record.item);
  }

  async function renderSortedWishlistGrid(shell, value) {
    const list = shell?.querySelector('[data-wm-wishlist-list]');
    const status = shell?.querySelector('[data-wm-wishlist-status]');
    const moreWrap = shell?.querySelector('[data-wm-wishlist-more-wrap]');
    const moreButton = shell?.querySelector('[data-wm-wishlist-more]');
    const items = Array.isArray(shell?.__wmWishlistItems) ? shell.__wmWishlistItems : [];
    if (!list || !items.length) return;

    shell.__wmWishlistRenderedCount = 0;
    shell.__wmWishlistActiveSort = value;
    if (moreButton) moreButton.disabled = true;
    if (status) {
      status.hidden = false;
      status.innerHTML = '<div class="wm-feed-loading" aria-label="Loading"><div class="spinner"></div></div>';
    }
    list.innerHTML = '';
    list.hidden = true;
    if (moreWrap) moreWrap.hidden = true;

    const sortedItems = await sortWishlistItems(items, value);
    shell.__wmWishlistSortedItems = sortedItems;
    const renderedCount = await renderTiles(shell, sortedItems, 0);
    shell.__wmWishlistRenderedCount = renderedCount;
    if (status) status.hidden = true;
    if (shell.__wmWishlistInfinite) {
      shell.__wmWishlistInfinite.update();
      shell.__wmWishlistInfinite.scheduleCheck();
    } else if (moreWrap) {
      moreWrap.hidden = renderedCount >= sortedItems.length;
    }
    if (moreButton) moreButton.disabled = false;
    scheduleCartButtonAlignment(shell);
    setTimeout(() => scheduleCartButtonAlignment(shell), 350);
  }

  function sortWishlistGrid(shell, value) {
    renderSortedWishlistGrid(shell, value).catch(() => {
      const status = shell?.querySelector('[data-wm-wishlist-status]');
      if (status) {
        status.hidden = false;
        status.textContent = 'Wishlist products could not be sorted.';
      }
    });
  }

  function sortVisibleWishlistGrid(shell, value) {
    const list = shell?.querySelector('[data-wm-wishlist-list]');
    if (!list) return;
    const tiles = Array.from(list.children);
    const sorted = tiles.slice();
    if (value === 'wm-random') {
      for (let index = sorted.length - 1; index > 0; index -= 1) {
        const swapIndex = Math.floor(Math.random() * (index + 1));
        [sorted[index], sorted[swapIndex]] = [sorted[swapIndex], sorted[index]];
      }
    } else if (value === 'price-ascending') {
      sorted.sort((a, b) => tileSortPrice(a) - tileSortPrice(b));
    } else if (value === 'price-descending') {
      sorted.sort((a, b) => tileSortPrice(b) - tileSortPrice(a));
    } else if (value === 'title-ascending') {
      sorted.sort((a, b) => tileSortText(a).localeCompare(tileSortText(b)));
    } else if (value === 'title-descending') {
      sorted.sort((a, b) => tileSortText(b).localeCompare(tileSortText(a)));
    } else {
      sorted.sort((a, b) => Number(a.dataset.wmWishlistOriginalIndex || 0) - Number(b.dataset.wmWishlistOriginalIndex || 0));
    }
    sorted.forEach((tile) => list.appendChild(tile));
    scheduleCartButtonAlignment(shell);
  }

  function installWishlistSelects(root) {
    const selects = Array.from(root.querySelectorAll('[data-wm-wishlist-sort]'));
    if (!selects.length) return;
    const openControls = new Set();
    const cleanText = (value) => String(value || '').replace(/\s+/g, ' ').trim();
    const selectedOption = (select) => select.options[select.selectedIndex] || select.querySelector('option');

    function closeControl(control) {
      if (!control) return;
      control.classList.remove('is-open');
      control.querySelector('.wm-select__button')?.setAttribute('aria-expanded', 'false');
      const panel = control.querySelector('.wm-select__panel');
      if (panel) panel.hidden = true;
      openControls.delete(control);
    }

    function closeAll(except) {
      Array.from(openControls).forEach((control) => {
        if (control !== except) closeControl(control);
      });
    }

    function openControl(control) {
      closeAll(control);
      control.classList.add('is-open');
      control.querySelector('.wm-select__button')?.setAttribute('aria-expanded', 'true');
      const panel = control.querySelector('.wm-select__panel');
      if (panel) panel.hidden = false;
      openControls.add(control);
    }

    function refreshControl(select, control) {
      const current = selectedOption(select);
      const label = cleanText(current?.textContent || '');
      const valueEl = control.querySelector('.wm-select__value');
      if (valueEl) valueEl.textContent = label || 'Select';
      control.querySelectorAll('.wm-select__option').forEach((button) => {
        const selected = button.dataset.value === select.value;
        button.classList.toggle('is-selected', selected);
        button.setAttribute('aria-selected', selected ? 'true' : 'false');
      });
    }

    function enhanceSelect(select) {
      if (!select || select.dataset.wmGridEnhanced === '1') return;

      const control = document.createElement('div');
      control.className = 'wm-select';
      control.dataset.wmSelectKind = 'sort';

      const button = document.createElement('button');
      button.className = 'wm-select__button';
      button.type = 'button';
      button.setAttribute('aria-haspopup', 'listbox');
      button.setAttribute('aria-expanded', 'false');
      button.innerHTML = '<span class="wm-select__button-main"><span class="wm-select__value"></span></span><svg class="wm-select__chevron" viewBox="0 0 13 8" aria-hidden="true" focusable="false"><path d="M1 1l5.5 5L12 1" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>';

      const panel = document.createElement('div');
      panel.className = 'wm-select__panel';
      panel.hidden = true;
      panel.setAttribute('role', 'listbox');

      const section = document.createElement('div');
      section.className = 'wm-select__section';
      Array.from(select.options).forEach((option) => {
        const row = document.createElement('button');
        row.className = 'wm-select__option';
        row.type = 'button';
        row.dataset.value = option.value;
        row.setAttribute('role', 'option');
        row.innerHTML = '<span><span class="wm-select__option-title"></span><span class="wm-select__option-subtitle"></span></span>';
        row.querySelector('.wm-select__option-title').textContent = cleanText(option.textContent);
        row.querySelector('.wm-select__option-subtitle').hidden = true;
        row.addEventListener('click', () => {
          if (select.value !== option.value) {
            select.value = option.value;
            select.dispatchEvent(new Event('change', { bubbles: true }));
          }
          refreshControl(select, control);
          closeControl(control);
        });
        section.appendChild(row);
      });
      panel.appendChild(section);

      control.appendChild(button);
      control.appendChild(panel);
      select.insertAdjacentElement('afterend', control);
      select.classList.add('wm-native-select-enhanced');
      select.dataset.wmGridEnhanced = '1';

      button.addEventListener('click', (event) => {
        event.stopPropagation();
        if (control.classList.contains('is-open')) {
          closeControl(control);
        } else {
          openControl(control);
        }
      });
      select.addEventListener('change', () => refreshControl(select, control));
      refreshControl(select, control);
    }

    selects.forEach(enhanceSelect);
    if (!root.dataset.wmWishlistSelectCloseInstalled) {
      root.dataset.wmWishlistSelectCloseInstalled = '1';
      document.addEventListener('click', (event) => {
        if (!event.target.closest('.wm-select')) closeAll();
      });
      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') closeAll();
      });
    }
  }

  async function renderTiles(shell, items, startIndex = 0) {
    const list = shell.querySelector('[data-wm-wishlist-list]');
    const byHandle = new Map();
    items.forEach((item) => {
      const handle = wishlistItemHandle(item);
      if (handle && !byHandle.has(handle)) byHandle.set(handle, item);
    });
    const uniqueItems = Array.from(byHandle.values());
    const batch = uniqueItems.slice(startIndex, startIndex + PAGE_SIZE);
    const tiles = await Promise.all(batch.map(async (item, offset) => {
      const handle = wishlistItemHandle(item);
      const [tile, product, indexItem] = await Promise.all([
        fetchGridTile(handle, startIndex + offset).catch(() => null),
        productJson(handle).catch(() => null),
        collectionIndexItem(handle).catch(() => null)
      ]);
      if (tile) {
        tile.dataset.wmWishlistOriginalIndex = String(startIndex + offset);
        addWishlistRemoveButton(tile, item);
        addWishlistCartButton(tile, item, product, indexItem);
      }
      return tile;
    }));

    tiles.filter(Boolean).forEach((tile) => {
      list.appendChild(tile);
    });

    list.hidden = list.children.length === 0;
    markWishlistOwnedButtons(shell);
    refreshWishlistButtons();
    setTimeout(() => markWishlistOwnedButtons(shell), 350);
    setTimeout(refreshWishlistButtons, 800);
    scheduleCartButtonAlignment(shell);

    return startIndex + batch.length;
  }

  function installWishlistInfiniteScroll(shell) {
    if (!shell) return null;
    shell.__wmWishlistInfinite?.destroy?.();

    const sentinel = shell.querySelector('[data-wm-wishlist-sentinel]');
    const moreWrap = shell.querySelector('[data-wm-wishlist-more-wrap]');
    const moreButton = shell.querySelector('[data-wm-wishlist-more]');
    const supportsObserver = 'IntersectionObserver' in window;
    let loading = false;
    let rafId = 0;
    let observer = null;

    const activeItems = () => (
      Array.isArray(shell.__wmWishlistSortedItems)
        ? shell.__wmWishlistSortedItems
        : (Array.isArray(shell.__wmWishlistItems) ? shell.__wmWishlistItems : [])
    );

    const hasMore = () => Number(shell.__wmWishlistRenderedCount || 0) < activeItems().length;

    function update() {
      const more = hasMore();
      if (sentinel) sentinel.hidden = !more;
      if (moreWrap) moreWrap.hidden = supportsObserver || !more;
      if (moreButton) moreButton.disabled = loading || !more;
    }

    function isNearSentinel() {
      if (!sentinel || sentinel.hidden) return false;
      const rect = sentinel.getBoundingClientRect();
      const preloadDistance = Math.max(1200, window.innerHeight * 2);
      return rect.top <= window.innerHeight + preloadDistance;
    }

    async function loadNextBatch() {
      if (loading || !hasMore()) {
        update();
        return;
      }

      loading = true;
      sentinel?.classList.add('is-loading');
      update();

      try {
        const items = activeItems();
        const renderedCount = Number(shell.__wmWishlistRenderedCount || 0);
        shell.__wmWishlistRenderedCount = await renderTiles(shell, items, renderedCount);
        scheduleCartButtonAlignment(shell);
      } catch (err) {
        if (moreWrap && !supportsObserver) moreWrap.hidden = false;
      } finally {
        loading = false;
        sentinel?.classList.remove('is-loading');
        update();
        scheduleCheck();
      }
    }

    function check() {
      rafId = 0;
      if (hasMore() && isNearSentinel()) loadNextBatch();
    }

    function scheduleCheck() {
      if (rafId) return;
      rafId = window.requestAnimationFrame(check);
    }

    const onScroll = () => scheduleCheck();
    const onResize = () => scheduleCheck();

    if (supportsObserver && sentinel) {
      observer = new IntersectionObserver((entries) => {
        if (entries.some((entry) => entry.isIntersecting)) loadNextBatch();
      }, { rootMargin: '1400px 0px 1800px', threshold: 0 });
      observer.observe(sentinel);
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onResize);
    window.addEventListener('orientationchange', onResize);
    moreButton?.addEventListener('click', loadNextBatch);

    const api = {
      loadNextBatch,
      update,
      scheduleCheck,
      destroy() {
        if (rafId) window.cancelAnimationFrame(rafId);
        observer?.disconnect();
        window.removeEventListener('scroll', onScroll);
        window.removeEventListener('resize', onResize);
        window.removeEventListener('orientationchange', onResize);
        moreButton?.removeEventListener('click', loadNextBatch);
      }
    };

    shell.__wmWishlistInfinite = api;
    update();
    [50, 250, 750, 1500].forEach((delay) => setTimeout(scheduleCheck, delay));
    return api;
  }

  function scheduleCartButtonAlignment(shell) {
    clearTimeout(cartButtonAlignTimer);
    cartButtonAlignTimer = setTimeout(() => alignCartButtonsByRow(shell), 80);
  }

  function alignCartButtonsByRow(shell) {
    if (!shell) return;
    const buttons = Array.from(shell.querySelectorAll('.wm-wishlist-cart-button'));
    buttons.forEach((button) => {
      button.style.removeProperty('--wm-atc-align-offset');
    });
    if (buttons.length < 2) return;

    const rows = new Map();
    buttons.forEach((button) => {
      const tile = button.closest('.wm-index-grid__item') || button.closest('li') || button.closest('.wm-wishlist-owned-tile');
      if (!tile || tile.classList.contains('is-wishlist-removing')) return;
      const rowKey = Math.round(tile.getBoundingClientRect().top / 8) * 8;
      const row = rows.get(rowKey) || [];
      row.push({ button, top: button.getBoundingClientRect().top });
      rows.set(rowKey, row);
    });

    rows.forEach((row) => {
      if (row.length < 2) return;
      const targetTop = Math.max(...row.map((item) => item.top));
      row.forEach(({ button, top }) => {
        const offset = Math.max(0, targetTop - top);
        button.style.setProperty('--wm-atc-align-offset', `${offset}px`);
      });
    });
  }

  function installStyles() {
    if (document.getElementById('wmWishlistGridStyles')) return;
    const style = document.createElement('style');
    style.id = 'wmWishlistGridStyles';
    style.textContent = `
      html.${GRID_CLASS},
      html.${GRID_CLASS} body,
      html.${GRID_CLASS} main,
      html.${GRID_CLASS} #MainContent,
      html.${GRID_CLASS} .bg-scheme-background {
        background: #2B2424 !important;
        background-color: #2B2424 !important;
      }
      html.${GRID_CLASS} body > header,
      html.${GRID_CLASS} .site-header,
      html.${GRID_CLASS} #shopify-section-header,
      html.${GRID_CLASS} [id^="shopify-section-header"],
      html.${GRID_CLASS} [data-section-type="header"] {
        background: #EAB782 !important;
        background-color: #EAB782 !important;
        color: #2B2424 !important;
      }
      html.${GRID_CLASS} body > header a,
      html.${GRID_CLASS} body > header button,
      html.${GRID_CLASS} .site-header a,
      html.${GRID_CLASS} .site-header button,
      html.${GRID_CLASS} #shopify-section-header a,
      html.${GRID_CLASS} #shopify-section-header button,
      html.${GRID_CLASS} [id^="shopify-section-header"] a,
      html.${GRID_CLASS} [id^="shopify-section-header"] button,
      html.${GRID_CLASS} [data-section-type="header"] a,
      html.${GRID_CLASS} [data-section-type="header"] button {
        color: #2B2424 !important;
      }
      html.${GRID_CLASS} body > header svg,
      html.${GRID_CLASS} .site-header svg,
      html.${GRID_CLASS} #shopify-section-header svg,
      html.${GRID_CLASS} [id^="shopify-section-header"] svg,
      html.${GRID_CLASS} [data-section-type="header"] svg {
        color: #2B2424 !important;
        stroke: currentColor !important;
      }
      html.${GRID_CLASS} footer,
      html.${GRID_CLASS} .site-footer,
      html.${GRID_CLASS} .footer,
      html.${GRID_CLASS} [data-section-type="footer"],
      html.${GRID_CLASS} [id^="shopify-section-footer"],
      html.${GRID_CLASS} [id*="__footer"],
      html.${GRID_CLASS} .shopify-section-group-footer-group,
      html.${GRID_CLASS} [id^="shopify-section-sections--"][id$="__footer"],
      html.${GRID_CLASS} [class*="footer-group"] {
        background: #EAB782 !important;
        background-color: #EAB782 !important;
        color: #2B2424 !important;
      }
      html.${GRID_CLASS} footer *,
      html.${GRID_CLASS} .site-footer *,
      html.${GRID_CLASS} .footer *,
      html.${GRID_CLASS} [data-section-type="footer"] *,
      html.${GRID_CLASS} [id^="shopify-section-footer"] *,
      html.${GRID_CLASS} [id*="__footer"] *,
      html.${GRID_CLASS} .shopify-section-group-footer-group *,
      html.${GRID_CLASS} [id^="shopify-section-sections--"][id$="__footer"] *,
      html.${GRID_CLASS} [class*="footer-group"] * {
        border-color: rgba(43, 36, 36, 0.22) !important;
      }
      html.${GRID_CLASS} footer a,
      html.${GRID_CLASS} footer button,
      html.${GRID_CLASS} .site-footer a,
      html.${GRID_CLASS} .site-footer button,
      html.${GRID_CLASS} .footer a,
      html.${GRID_CLASS} .footer button,
      html.${GRID_CLASS} [data-section-type="footer"] a,
      html.${GRID_CLASS} [data-section-type="footer"] button,
      html.${GRID_CLASS} [id^="shopify-section-footer"] a,
      html.${GRID_CLASS} [id^="shopify-section-footer"] button,
      html.${GRID_CLASS} [id*="__footer"] a,
      html.${GRID_CLASS} [id*="__footer"] button,
      html.${GRID_CLASS} .shopify-section-group-footer-group a,
      html.${GRID_CLASS} .shopify-section-group-footer-group button,
      html.${GRID_CLASS} [id^="shopify-section-sections--"][id$="__footer"] a,
      html.${GRID_CLASS} [id^="shopify-section-sections--"][id$="__footer"] button,
      html.${GRID_CLASS} [class*="footer-group"] a,
      html.${GRID_CLASS} [class*="footer-group"] button {
        color: #2B2424 !important;
      }
      html.${GRID_CLASS} wishlist-page {
        display: none !important;
      }
      body.wm-grid-player-open {
        padding-bottom: 112px;
      }
      .wm-wishlist-grid {
        background: #2B2424;
        color: #FFF2E9;
        min-height: 100vh;
        font-family: "Poppins", system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif;
      }
      .wm-wishlist-grid__inner {
        width: min(1800px, calc(100vw - 96px));
        margin: 0 auto;
        padding: 12px 0 104px;
      }
      .wm-wishlist-grid__header {
        display: flex;
        justify-content: center;
        margin: 0 0 28px;
      }
      .wm-wishlist-feed-toolbar {
        display: grid;
        grid-template-columns: minmax(0, 196px) minmax(0, 196px) 46px;
        gap: 8px;
        justify-content: center;
        width: min(100%, 458px);
      }
      .wm-wishlist-grid__bulk,
      .wm-wishlist-grid__more,
      .wm-wishlist-grid__view-toggle,
      .wm-wishlist-grid__sort {
        min-height: 40px;
        border: 1.5px solid #FFF2E9;
        border-radius: 12px;
        background: #2B2424;
        color: #FFF2E9;
        padding: 0 14px;
        font: inherit;
        font-size: 0.78rem;
        font-weight: 800;
        letter-spacing: 0.06em;
        text-transform: uppercase;
        cursor: pointer;
        box-sizing: border-box;
      }
      .wm-wishlist-grid__bulk,
      .wm-wishlist-grid__sort {
        width: 100%;
      }
      .wm-wishlist-grid__view-toggle {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        text-decoration: none;
        padding: 0;
        border-radius: 12px;
      }
      .wm-wishlist-grid__view-toggle svg {
        width: 23px;
        height: 23px;
      }
      .wm-wishlist-grid .wm-native-select-enhanced {
        display: none !important;
      }
      .wm-wishlist-grid .wm-select {
        position: relative;
        min-width: 0;
        width: 100%;
      }
      .wm-wishlist-grid .wm-select__button {
        width: 100%;
        height: 40px;
        min-height: 40px;
        border: 1.5px solid #FFF2E9;
        border-radius: 12px;
        background: #2B2424;
        color: #FFF2E9;
        display: grid;
        grid-template-columns: minmax(0, 1fr) auto;
        align-items: center;
        justify-items: stretch;
        gap: 10px;
        padding: 0 12px;
        font: inherit;
        font-size: 0.78rem;
        font-weight: 800;
        letter-spacing: 0.06em;
        text-transform: uppercase;
        cursor: pointer;
        box-sizing: border-box;
      }
      .wm-wishlist-grid .wm-select__button-main,
      .wm-wishlist-grid .wm-select__value {
        min-width: 0;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        font-size: 0.78rem;
        font-weight: 800;
        letter-spacing: 0.06em;
        text-transform: uppercase;
        text-align: left;
        justify-self: start;
      }
      .wm-wishlist-grid .wm-select__chevron {
        width: 13px;
        height: 8px;
        transition: transform 160ms ease;
      }
      .wm-wishlist-grid .wm-select.is-open .wm-select__chevron {
        transform: rotate(180deg);
      }
      .wm-wishlist-grid .wm-select__panel {
        position: absolute;
        top: calc(100% + 8px);
        left: 0;
        right: 0;
        z-index: 60;
        min-width: 260px;
        padding: 14px 10px;
        border: 1px solid rgba(255, 242, 233, 0.2);
        border-radius: 12px;
        background: rgba(43, 36, 36, 0.96);
        color: #FFF2E9;
        box-shadow: 0 18px 42px rgba(0, 0, 0, 0.34);
        backdrop-filter: blur(12px);
        -webkit-backdrop-filter: blur(12px);
      }
      .wm-wishlist-grid .wm-select__option {
        width: 100%;
        min-height: 38px;
        border: 0;
        border-radius: 8px;
        background: transparent;
        color: #FFF2E9;
        display: flex;
        align-items: center;
        padding: 0 10px;
        text-align: left;
        font: inherit;
        font-size: 0.75rem;
        font-weight: 800;
        letter-spacing: 0.04em;
        text-transform: uppercase;
        cursor: pointer;
      }
      .wm-wishlist-grid .wm-select__option:hover,
      .wm-wishlist-grid .wm-select__option:focus-visible,
      .wm-wishlist-grid .wm-select__option.is-selected {
        background: #FF7A33;
        color: #FFF2E9;
        outline: none;
      }
      .wm-wishlist-grid .wm-select__option-subtitle[hidden] {
        display: none;
      }
      .wm-wishlist-grid__status {
        min-height: 220px;
        display: grid;
        place-items: center;
        color: rgba(255, 242, 233, 0.8);
        font-weight: 800;
        text-align: center;
      }
      .wm-wishlist-grid__status[hidden] {
        display: none !important;
      }
      .wm-wishlist-grid__items {
        list-style: none;
        margin: 0;
        padding: 0;
      }
      .wm-wishlist-grid__items .product-tile {
        color: #FFF2E9;
      }
      .wm-wishlist-grid__items .product-tile a,
      .wm-wishlist-grid__items .product-tile .product-title,
      .wm-wishlist-grid__items .product-tile .price,
      .wm-wishlist-grid__items .product-tile .unit-price {
        color: #FFF2E9;
      }
      .wm-wishlist-grid [id^="sold-out-sticker"],
      .wm-wishlist-grid [class*="sold-out-sticker"],
      .wm-wishlist-grid [class*="sold_out"],
      .wm-wishlist-grid [data-static-id="sold-out"] {
        display: none !important;
      }
      .wm-wishlist-cart-button {
        width: 100%;
        min-height: 38px;
        margin-top: calc(14px + var(--wm-atc-align-offset, 0px));
        border: 1.5px solid rgba(255, 242, 233, 0.9);
        border-radius: 8px;
        background: transparent;
        color: #FFF2E9;
        font: inherit;
        font-size: 0.72rem;
        line-height: 1;
        font-weight: 800;
        letter-spacing: 0.04em;
        text-transform: uppercase;
        cursor: pointer;
        transition: background-color 160ms ease, border-color 160ms ease, color 160ms ease, opacity 160ms ease;
      }
      .wm-wishlist-cart-button:hover,
      .wm-wishlist-cart-button:focus-visible {
        background: #EAB782;
        border-color: #EAB782;
        color: #2B2424;
      }
      .wm-wishlist-cart-button:disabled {
        cursor: default;
        opacity: 0.7;
      }
      .wm-wishlist-cart-button.is-added {
        background: #EAB782;
        border-color: #EAB782;
        color: #2B2424;
      }
      .wm-wishlist-cart-button.is-sold-out,
      .wm-wishlist-cart-button.is-sold-out:hover,
      .wm-wishlist-cart-button.is-sold-out:focus-visible {
        border-color: rgba(255, 242, 233, 0.38);
        background: transparent;
        color: rgba(255, 242, 233, 0.48);
        cursor: not-allowed;
        opacity: 1;
      }
      .wm-wishlist-grid__more-wrap {
        display: flex;
        justify-content: center;
        margin-top: 36px;
      }
      .wm-wishlist-grid__more-wrap[hidden] {
        display: none !important;
      }
      .wm-wishlist-grid__sentinel {
        min-height: 120px;
        display: flex;
        align-items: center;
        justify-content: center;
      }
      .wm-wishlist-grid__sentinel[hidden] {
        display: none !important;
      }
      .wm-wishlist-grid__sentinel.is-loading::after {
        content: '';
        width: 34px;
        height: 34px;
        border: 3px solid #eab782;
        border-top-color: #cba957;
        border-radius: 50%;
        animation: wmWishlistGridSpin 1s linear infinite;
      }
      .wm-feed-loading {
        display: flex;
        justify-content: center;
        align-items: center;
        min-height: 80px;
      }
      .wm-feed-loading .spinner {
        width: 40px;
        height: 40px;
        border: 4px solid #eab782;
        border-top: 4px solid #cba957;
        border-radius: 50%;
        animation: wmWishlistGridSpin 1s linear infinite;
      }
      @keyframes wmWishlistGridSpin {
        to { transform: rotate(360deg); }
      }
      html.${GRID_READY_CLASS} .wm-wishlist-grid .wm-grid-audio-card .product-tile__featured-media {
        position: relative;
        overflow: hidden;
      }
      html.${GRID_READY_CLASS} .wm-wishlist-grid .product-tile__featured-media {
        position: relative;
      }
      html.${GRID_READY_CLASS} .wm-grid-audio-overlay {
        position: absolute;
        inset: 0;
        z-index: 4;
        display: flex;
        align-items: center;
        justify-content: center;
        color: #FFF2E9;
        text-decoration: none;
        pointer-events: none;
      }
      html.${GRID_READY_CLASS} .wm-grid-audio-overlay__button {
        width: clamp(48px, 14%, 64px);
        aspect-ratio: 1;
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        border: 0;
        border-radius: 999px;
        background: rgba(0, 0, 0, 0.68);
        color: #FFF2E9;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        box-shadow: 0 10px 30px rgba(0, 0, 0, 0.28);
        backdrop-filter: blur(3px);
        -webkit-backdrop-filter: blur(3px);
        pointer-events: auto;
        cursor: pointer;
      }
      html.${GRID_READY_CLASS} .wm-grid-audio-overlay__icon {
        width: 52%;
        height: 52%;
        fill: currentColor;
      }
      html.${GRID_READY_CLASS} .wm-grid-audio-overlay__icon--pause,
      html.${GRID_READY_CLASS} .wm-grid-audio-card.is-grid-audio-playing .wm-grid-audio-overlay__icon--play {
        display: none;
      }
      html.${GRID_READY_CLASS} .wm-grid-audio-card.is-grid-audio-playing .wm-grid-audio-overlay__icon--pause {
        display: block;
      }
      html.${GRID_READY_CLASS} .wm-grid-swish-anchor {
        position: absolute;
        top: 10px;
        right: 10px;
        z-index: 7;
        width: 38px;
        height: 38px;
        min-width: 38px;
        min-height: 38px;
        border-radius: 999px !important;
        background: transparent !important;
        box-shadow: none !important;
        pointer-events: auto;
      }
      html.${GRID_READY_CLASS} .wm-wishlist-grid .wm-wishlist-owned-tile .wm-grid-swish-anchor,
      html.${GRID_READY_CLASS} .wm-wishlist-grid .wm-wishlist-native-heart-hidden {
        display: none !important;
        visibility: hidden !important;
        pointer-events: none !important;
      }
      html.${GRID_READY_CLASS} .wm-wishlist-owned-tile {
        transition: opacity 180ms ease, transform 180ms ease;
      }
      html.${GRID_READY_CLASS} .wm-wishlist-owned-tile.is-wishlist-removing {
        opacity: 0;
        transform: translateY(-10px) scale(0.985);
        pointer-events: none;
      }
      html.${GRID_READY_CLASS} .wm-wishlist-remove-button {
        position: absolute;
        top: 10px;
        right: 10px;
        z-index: 8;
        width: 38px;
        height: 38px;
        min-width: 38px;
        min-height: 38px;
        border: 1.5px solid rgba(255, 242, 233, 0.9);
        border-radius: 999px;
        background-color: rgba(43, 36, 36, 0.72);
        background-position: center;
        background-repeat: no-repeat;
        background-size: 20px 20px;
        background-image: url("data:image/svg+xml,%3Csvg%20viewBox%3D%270%200%2024%2024%27%20xmlns%3D%27http%3A//www.w3.org/2000/svg%27%3E%3Cpath%20d%3D%27M20.84%204.61a5.5%205.5%200%200%200-7.78%200L12%205.67l-1.06-1.06a5.5%205.5%200%200%200-7.78%207.78L12%2021.23l8.84-8.84a5.5%205.5%200%200%200%200-7.78Z%27%20fill%3D%27%23FFF2E9%27%20stroke%3D%27%23FFF2E9%27%20stroke-width%3D%271.45%27%20stroke-linecap%3D%27round%27%20stroke-linejoin%3D%27round%27/%3E%3C/svg%3E");
        color: #FFF2E9;
        cursor: pointer;
        padding: 0;
        box-shadow: 0 8px 18px rgba(0, 0, 0, 0.28);
      }
      html.${GRID_READY_CLASS} .wm-wishlist-remove-button:disabled {
        cursor: default;
        opacity: 0.68;
      }
      html.${GRID_READY_CLASS} .wm-wishlist-remove-button .visually-hidden {
        position: absolute !important;
        width: 1px !important;
        height: 1px !important;
        padding: 0 !important;
        margin: -1px !important;
        overflow: hidden !important;
        clip: rect(0, 0, 0, 0) !important;
        white-space: nowrap !important;
        border: 0 !important;
      }
      html.${GRID_READY_CLASS} .wm-grid-swish-anchor .ajax-cart-form,
      html.${GRID_READY_CLASS} .wm-grid-swish-anchor .add-to-cart,
      html.${GRID_READY_CLASS} .wm-grid-swish-anchor .cart-text,
      html.${GRID_READY_CLASS} .wm-grid-swish-anchor .view-product-button {
        display: none !important;
      }
      html.${GRID_READY_CLASS} .wm-grid-swish-anchor .button-group {
        display: flex !important;
        align-items: center !important;
        justify-content: center !important;
        width: 100% !important;
        height: 100% !important;
        padding: 0 !important;
        margin: 0 !important;
        border: 0 !important;
        background: transparent !important;
      }
      html.${GRID_READY_CLASS} .wm-grid-swish-anchor .wk-button,
      html.${GRID_READY_CLASS} .wm-grid-swish-anchor .wk-button:hover,
      html.${GRID_READY_CLASS} .wm-grid-swish-anchor .wk-button:focus,
      html.${GRID_READY_CLASS} .wm-grid-swish-anchor .wk-button:focus-visible,
      html.${GRID_READY_CLASS} .wm-grid-swish-anchor .wk-button:active {
        width: 38px !important;
        height: 38px !important;
        min-width: 38px !important;
        min-height: 38px !important;
        border: 1.5px solid rgba(255, 242, 233, 0.9) !important;
        border-radius: 999px !important;
        background-color: rgba(43, 36, 36, 0.72) !important;
        background-position: center !important;
        background-repeat: no-repeat !important;
        background-size: 20px 20px !important;
        background-image: url("data:image/svg+xml,%3Csvg%20viewBox%3D%270%200%2024%2024%27%20xmlns%3D%27http%3A//www.w3.org/2000/svg%27%3E%3Cpath%20d%3D%27M20.84%204.61a5.5%205.5%200%200%200-7.78%200L12%205.67l-1.06-1.06a5.5%205.5%200%200%200-7.78%207.78L12%2021.23l8.84-8.84a5.5%205.5%200%200%200%200-7.78Z%27%20fill%3D%27none%27%20stroke%3D%27%23FFF2E9%27%20stroke-width%3D%271.45%27%20stroke-linecap%3D%27round%27%20stroke-linejoin%3D%27round%27/%3E%3C/svg%3E") !important;
        color: #FFF2E9 !important;
        display: inline-flex !important;
        align-items: center !important;
        justify-content: center !important;
        font-size: 0 !important;
        line-height: 0 !important;
        padding: 0 !important;
        margin: 0 !important;
        box-shadow: 0 8px 18px rgba(0, 0, 0, 0.28) !important;
        overflow: hidden !important;
      }
      html.${GRID_READY_CLASS} .wm-grid-swish-anchor .wk-button.wk-selected,
      html.${GRID_READY_CLASS} .wm-grid-swish-anchor .wk-button.is-active,
      html.${GRID_READY_CLASS} .wm-grid-swish-anchor .wk-button[aria-pressed="true"],
      html.${GRID_READY_CLASS} .wm-grid-swish-anchor .wk-button.wm-wishlist-owned {
        background-image: url("data:image/svg+xml,%3Csvg%20viewBox%3D%270%200%2024%2024%27%20xmlns%3D%27http%3A//www.w3.org/2000/svg%27%3E%3Cpath%20d%3D%27M20.84%204.61a5.5%205.5%200%200%200-7.78%200L12%205.67l-1.06-1.06a5.5%205.5%200%200%200-7.78%207.78L12%2021.23l8.84-8.84a5.5%205.5%200%200%200%200-7.78Z%27%20fill%3D%27%23FFF2E9%27%20stroke%3D%27%23FFF2E9%27%20stroke-width%3D%271.45%27%20stroke-linecap%3D%27round%27%20stroke-linejoin%3D%27round%27/%3E%3C/svg%3E") !important;
      }
      html.${GRID_READY_CLASS} .wm-grid-swish-anchor .wk-button svg,
      html.${GRID_READY_CLASS} .wm-grid-swish-anchor .wk-button wk-icon,
      html.${GRID_READY_CLASS} .wm-grid-swish-anchor .wk-button > * {
        display: none !important;
      }
      .wm-grid-global-player {
        position: fixed;
        left: 0;
        right: 0;
        bottom: 0;
        z-index: 40;
        min-height: 86px;
        background: rgba(43, 36, 36, 0.94);
        color: #FFF2E9;
        box-shadow: inset 0 1px 0 rgba(255, 242, 233, 0.12), 0 -14px 34px rgba(0, 0, 0, 0.32);
        backdrop-filter: blur(10px);
        -webkit-backdrop-filter: blur(10px);
        transform: translateY(105%);
        transition: transform 180ms ease;
        font-family: "Poppins", sans-serif;
        touch-action: pan-y;
      }
      .wm-grid-global-player.is-visible {
        transform: translateY(0);
      }
      .wm-grid-global-player__inner {
        position: relative;
        width: min(1180px, calc(100% - 28px));
        min-height: 86px;
        margin: 0 auto;
        display: grid;
        grid-template-columns: minmax(0, 280px) auto minmax(220px, 1fr) auto;
        align-items: center;
        gap: 0.85rem;
        padding: 0.65rem 0;
      }
      .wm-grid-global-player__release {
        min-width: 0;
        display: grid;
        grid-template-columns: 48px minmax(0, 1fr);
        align-items: center;
        gap: 0.65rem;
        color: inherit;
        text-decoration: none;
      }
      .wm-grid-global-player__cover {
        width: 48px;
        height: 48px;
        object-fit: cover;
        border-radius: 4px;
        background: rgba(255, 242, 233, 0.08);
        border: 1px solid rgba(255, 242, 233, 0.28);
      }
      .wm-grid-global-player__text {
        min-width: 0;
      }
      .wm-grid-global-player__title,
      .wm-grid-global-player__track {
        display: block;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        letter-spacing: 0;
      }
      .wm-grid-global-player__title {
        font-size: 0.78rem;
        line-height: 1.15;
        font-weight: 800;
      }
      .wm-grid-global-player__track {
        margin-top: 0.12rem;
        font-size: 0.72rem;
        line-height: 1.15;
        color: rgba(255, 242, 233, 0.75);
      }
      .wm-grid-global-player__controls {
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 0.45rem;
      }
      .wm-grid-global-player__button,
      .wm-grid-global-player__wishlist-fallback {
        width: 40px;
        height: 40px;
        border: 1.5px solid rgba(255, 242, 233, 0.85);
        border-radius: 999px;
        background: transparent;
        color: #FFF2E9;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        padding: 0;
        line-height: 0;
        box-sizing: border-box;
      }
      .wm-grid-global-player__button--play {
        width: 48px;
        height: 48px;
        background: #E8BD84;
        border-color: #E8BD84;
        color: #2B2424;
        position: relative;
      }
      .wm-grid-global-player__button svg {
        width: 54%;
        height: 54%;
        fill: currentColor;
      }
      .wm-grid-global-player__button--play svg {
        position: absolute;
        top: 50%;
        left: 50%;
        margin: 0;
      }
      .wm-grid-global-player__icon--pause {
        display: none !important;
        transform: translate(-50%, -50%);
      }
      .wm-grid-global-player__icon--play {
        transform: translate(-48%, -50%);
      }
      .wm-grid-global-player.is-playing .wm-grid-global-player__icon--play {
        display: none !important;
      }
      .wm-grid-global-player.is-playing .wm-grid-global-player__icon--pause {
        display: block !important;
      }
      .wm-grid-global-player__timeline {
        display: grid;
        grid-template-columns: auto minmax(0, 1fr) auto;
        align-items: center;
        gap: 0.55rem;
      }
      .wm-grid-global-player__time {
        min-width: 3.2rem;
        font-size: 0.7rem;
        color: rgba(255, 242, 233, 0.8);
        font-weight: 700;
        text-align: center;
      }
      .wm-grid-global-player__progress {
        width: 100%;
        min-height: 22px;
        display: flex;
        align-items: center;
        cursor: pointer;
        touch-action: none;
      }
      .wm-grid-global-player__progress-track {
        position: relative;
        width: 100%;
        height: 10px;
        border-radius: 999px;
        background: rgba(255, 242, 233, 0.24);
      }
      .wm-grid-global-player__progress-fill {
        position: absolute;
        inset: 0 auto 0 0;
        width: 0%;
        height: 100%;
        border-radius: inherit;
        background: #E8BD84;
      }
      .wm-grid-global-player__progress-dot {
        position: absolute;
        left: 0%;
        top: 50%;
        width: 16px;
        height: 16px;
        border-radius: 999px;
        background: #E8BD84;
        border: 2px solid #FFF2E9;
        transform: translate(-50%, -50%);
      }
      .wm-grid-global-player__actions {
        display: flex;
        align-items: center;
        justify-content: flex-end;
      }
      .wm-grid-global-player__wishlist-fallback {
        position: relative;
        background-position: center;
        background-repeat: no-repeat;
        background-size: 24px 24px;
        background-image: url("data:image/svg+xml,%3Csvg%20viewBox%3D%270%200%2024%2024%27%20xmlns%3D%27http%3A//www.w3.org/2000/svg%27%3E%3Cpath%20d%3D%27M20.84%204.61a5.5%205.5%200%200%200-7.78%200L12%205.67l-1.06-1.06a5.5%205.5%200%200%200-7.78%207.78L12%2021.23l8.84-8.84a5.5%205.5%200%200%200%200-7.78Z%27%20fill%3D%27none%27%20stroke%3D%27%23FFF2E9%27%20stroke-width%3D%271.45%27%20stroke-linecap%3D%27round%27%20stroke-linejoin%3D%27round%27/%3E%3C/svg%3E");
      }
      .wm-grid-global-player__wishlist-fallback.is-active {
        background-image: url("data:image/svg+xml,%3Csvg%20viewBox%3D%270%200%2024%2024%27%20xmlns%3D%27http%3A//www.w3.org/2000/svg%27%3E%3Cpath%20d%3D%27M20.84%204.61a5.5%205.5%200%200%200-7.78%200L12%205.67l-1.06-1.06a5.5%205.5%200%200%200-7.78%207.78L12%2021.23l8.84-8.84a5.5%205.5%200%200%200%200-7.78Z%27%20fill%3D%27%23FFF2E9%27%20stroke%3D%27%23FFF2E9%27%20stroke-width%3D%271.45%27%20stroke-linecap%3D%27round%27%20stroke-linejoin%3D%27round%27/%3E%3C/svg%3E");
      }
      .wm-grid-global-player__wishlist-fallback svg {
        display: none;
      }
      @media (max-width: 989px) {
        .wm-wishlist-grid__inner {
          width: min(100%, calc(100vw - 32px));
        }
      }
      @media (max-width: 749px) {
        body.wm-grid-player-open {
          padding-bottom: 122px;
        }
        .wm-wishlist-grid__inner {
          width: min(100%, calc(100vw - 24px));
          padding-top: 12px;
          padding-bottom: 72px;
        }
        .wm-wishlist-grid__header {
          margin-bottom: 24px;
        }
        .wm-wishlist-feed-toolbar {
          grid-template-columns: minmax(0, 1fr) minmax(0, 1fr) 44px;
          width: 100%;
        }
        .wm-wishlist-grid__bulk,
        .wm-wishlist-grid__sort,
        .wm-wishlist-grid__view-toggle,
        .wm-wishlist-grid .wm-select__button {
          min-height: 38px;
          height: 38px;
          border-radius: 10px;
          font-size: 0.78rem;
          font-weight: 800;
          letter-spacing: 0.06em;
          text-transform: uppercase;
          padding-left: 10px;
          padding-right: 10px;
        }
        .wm-wishlist-grid .wm-select__panel {
          min-width: 0;
          width: min(260px, 72vw);
          left: 50%;
          right: auto;
          transform: translateX(-50%);
        }
        .wm-wishlist-cart-button {
          min-height: 36px;
          margin-top: calc(10px + var(--wm-atc-align-offset, 0px));
          font-size: 0.66rem;
          border-radius: 7px;
        }
        .wm-grid-global-player {
          min-height: 108px;
        }
        .wm-grid-global-player__inner {
          width: calc(100% - 20px);
          min-height: 108px;
          grid-template-columns: minmax(0, 1fr) 122px 36px;
          grid-template-areas:
            "release controls actions"
            "timeline timeline timeline";
          gap: 0.48rem 3px;
          padding: 0.56rem 0 0.62rem;
        }
        .wm-grid-global-player__release {
          grid-area: release;
          grid-template-columns: 38px minmax(0, 1fr);
          gap: 0.5rem;
        }
        .wm-grid-global-player__cover {
          width: 38px;
          height: 38px;
        }
        .wm-grid-global-player__title {
          font-size: 0.72rem;
          line-height: 1.12;
        }
        .wm-grid-global-player__track {
          font-size: 0.66rem;
          line-height: 1.12;
        }
        .wm-grid-global-player__controls {
          grid-area: controls;
          width: 122px;
          gap: 4px;
          justify-self: end;
        }
        .wm-grid-global-player__button,
        .wm-grid-global-player__wishlist-fallback {
          width: 36px;
          height: 36px;
        }
        .wm-grid-global-player__wishlist-fallback {
          background-size: 20px 20px;
        }
        .wm-grid-global-player__button--play {
          width: 42px;
          height: 42px;
        }
        .wm-grid-global-player__timeline {
          grid-area: timeline;
          grid-template-columns: 2.75rem minmax(0, 1fr) 2.75rem;
          min-height: 22px;
          gap: 0.38rem;
        }
        .wm-grid-global-player__time {
          min-width: 2.75rem;
          font-size: 0.62rem;
        }
        .wm-grid-global-player__progress-track {
          height: 7px;
        }
        .wm-grid-global-player__actions {
          grid-area: actions;
          width: 36px;
          justify-content: flex-end;
          justify-self: end;
        }
      }
    `;
    document.head.appendChild(style);
  }

  function styleWishlistFooter() {
    const selectors = [
      'footer',
      '.site-footer',
      '.footer',
      '[data-section-type="footer"]',
      '[id^="shopify-section-footer"]',
      '[id*="__footer"]',
      '.shopify-section-group-footer-group',
      '[id^="shopify-section-sections--"][id$="__footer"]',
      '[class*="footer-group"]'
    ];
    document.querySelectorAll(selectors.join(',')).forEach((footer) => {
      footer.style.setProperty('background', '#EAB782', 'important');
      footer.style.setProperty('background-color', '#EAB782', 'important');
      footer.style.setProperty('color', '#2B2424', 'important');
    });
  }

  function installGridPlayer(shell) {
    if (!shell || shell.dataset.wmWishlistGridPlayer === '1') return;
    shell.dataset.wmWishlistGridPlayer = '1';

    const audio = new Audio();
    audio.preload = 'none';
    audio.playsInline = true;
    let activeOverlay = null;
    let activeCard = null;
    let activePlayButton = null;
    let activeTrackIndex = 0;
    let activeTracks = [];
    let activeTitles = [];
    let activeSrc = '';
    let progressDragActive = false;
    let playerSwipeStartX = 0;
    let playerSwipeStartY = 0;
    let playerSwipeStartTime = 0;

    const player = document.createElement('div');
    player.className = 'wm-grid-global-player';
    player.setAttribute('aria-live', 'polite');
    player.innerHTML = `
      <div class="wm-grid-global-player__inner">
        <a class="wm-grid-global-player__release" data-wm-grid-player-link href="#">
          <img class="wm-grid-global-player__cover" data-wm-grid-player-cover alt="">
          <div class="wm-grid-global-player__text">
            <span class="wm-grid-global-player__title" data-wm-grid-player-release>Preview</span>
            <span class="wm-grid-global-player__track" data-wm-grid-player-track>Track 1</span>
          </div>
        </a>
        <div class="wm-grid-global-player__controls">
          <button class="wm-grid-global-player__button" type="button" data-wm-grid-player-prev aria-label="Previous track">
            <svg viewBox="0 0 24 24" focusable="false" aria-hidden="true"><path d="M6 12l11-7v14L6 12Z"></path><rect x="4" y="5" width="2" height="14"></rect></svg>
          </button>
          <button class="wm-grid-global-player__button wm-grid-global-player__button--play" type="button" data-wm-grid-player-play aria-label="Play">
            <svg class="wm-grid-global-player__icon--play" viewBox="0 0 24 24" focusable="false" aria-hidden="true"><path d="M8 5v14l11-7L8 5z"></path></svg>
            <svg class="wm-grid-global-player__icon--pause" viewBox="0 0 24 24" focusable="false" aria-hidden="true"><path d="M6 19h4V5H6v14zm8-14v14h4V5h-4z"></path></svg>
          </button>
          <button class="wm-grid-global-player__button" type="button" data-wm-grid-player-next aria-label="Next track">
            <svg viewBox="0 0 24 24" focusable="false" aria-hidden="true"><path d="M18 12 7 19V5l11 7Z"></path><rect x="18" y="5" width="2" height="14"></rect></svg>
          </button>
        </div>
        <div class="wm-grid-global-player__timeline">
          <span class="wm-grid-global-player__time" data-wm-grid-player-current>0:00</span>
          <div class="wm-grid-global-player__progress" data-wm-grid-player-progress role="slider" tabindex="0" aria-label="Audio progress" aria-valuemin="0" aria-valuemax="100" aria-valuenow="0">
            <div class="wm-grid-global-player__progress-track">
              <span class="wm-grid-global-player__progress-fill" data-wm-grid-player-progress-fill></span>
              <span class="wm-grid-global-player__progress-dot" data-wm-grid-player-progress-dot></span>
            </div>
          </div>
          <span class="wm-grid-global-player__time" data-wm-grid-player-duration>0:00</span>
        </div>
        <div class="wm-grid-global-player__actions">
          <button class="wm-grid-global-player__wishlist-fallback" type="button" data-wm-grid-player-wishlist aria-label="Add to wishlist">
            <svg viewBox="0 0 24 24" focusable="false" aria-hidden="true"><path d="M20.8 4.6a5.4 5.4 0 0 0-7.6 0L12 5.8l-1.2-1.2a5.4 5.4 0 0 0-7.6 7.6L12 21l8.8-8.8a5.4 5.4 0 0 0 0-7.6Z"></path></svg>
          </button>
        </div>
      </div>
    `;
    document.body.appendChild(player);

    const coverEl = player.querySelector('[data-wm-grid-player-cover]');
    const releaseEl = player.querySelector('[data-wm-grid-player-release]');
    const trackEl = player.querySelector('[data-wm-grid-player-track]');
    const productLinkEl = player.querySelector('[data-wm-grid-player-link]');
    const playButton = player.querySelector('[data-wm-grid-player-play]');
    const prevButton = player.querySelector('[data-wm-grid-player-prev]');
    const nextButton = player.querySelector('[data-wm-grid-player-next]');
    const progressEl = player.querySelector('[data-wm-grid-player-progress]');
    const fillEl = player.querySelector('[data-wm-grid-player-progress-fill]');
    const dotEl = player.querySelector('[data-wm-grid-player-progress-dot]');
    const currentTimeEl = player.querySelector('[data-wm-grid-player-current]');
    const durationEl = player.querySelector('[data-wm-grid-player-duration]');
    const wishlistButton = player.querySelector('[data-wm-grid-player-wishlist]');

    function parseJsonAttribute(el, name) {
      try {
        const value = el.getAttribute(name);
        return value ? JSON.parse(value) : [];
      } catch (err) {
        return [];
      }
    }

    function formatTime(value) {
      const seconds = Math.max(0, Math.floor(Number(value) || 0));
      return `${Math.floor(seconds / 60)}:${String(seconds % 60).padStart(2, '0')}`;
    }

    function setProgress(percent) {
      const safePercent = Math.max(0, Math.min(100, Number(percent) || 0));
      if (fillEl) fillEl.style.width = `${safePercent}%`;
      if (dotEl) dotEl.style.left = `${safePercent}%`;
      if (progressEl) progressEl.setAttribute('aria-valuenow', String(Math.round(safePercent)));
    }

    function activeTileWishlistButton() {
      return activeCard ? activeCard.querySelector('.wm-wishlist-remove-button, .wm-grid-swish-anchor .wk-button') : null;
    }

    function wishlistButtonIsActive(button) {
      if (!button) return false;
      const state = [
        button.getAttribute('aria-pressed'),
        button.getAttribute('aria-label'),
        button.getAttribute('title'),
        button.getAttribute('data-state'),
        button.textContent,
        button.className
      ].join(' ').toLowerCase();
      return state.includes('true') || state.includes('remove') || state.includes('added') || state.includes('selected') || state.includes('active') || state.includes('in wishlist');
    }

    function setGlobalWishlistState(isActive) {
      if (!wishlistButton) return;
      wishlistButton.classList.toggle('is-active', !!isActive);
      wishlistButton.setAttribute('aria-pressed', isActive ? 'true' : 'false');
      wishlistButton.setAttribute('aria-label', isActive ? 'Remove from wishlist' : 'Add to wishlist');
    }

    function syncGlobalWishlistFromTile() {
      setGlobalWishlistState(wishlistButtonIsActive(activeTileWishlistButton()));
    }

    async function removeTileFromWishlist(button) {
      if (!button || button.disabled) return;
      const tile = button.closest('.wm-index-grid__item') || button.closest('li') || button.closest('.product-tile');
      const itemId = button.dataset.wmWishlistItemId || tile?.dataset.wmWishlistItemId || '';
      if (!tile || !itemId) return;

      button.disabled = true;
      button.dataset.wmWishlistGridTouched = '1';
      setTileWishlistState(button, false);
      if (tile === activeCard || tile.contains(activeCard)) setGlobalWishlistState(false);

      try {
        await removeWishlistItem(itemId);
        if (Array.isArray(shell.__wmWishlistItems)) {
          shell.__wmWishlistItems = shell.__wmWishlistItems.filter((item) => wishlistItemId(item) !== itemId);
        }
        if (Array.isArray(shell.__wmWishlistSortedItems)) {
          shell.__wmWishlistSortedItems = shell.__wmWishlistSortedItems.filter((item) => wishlistItemId(item) !== itemId);
        }
        shell.__wmWishlistRenderedCount = Math.max(0, Number(shell.__wmWishlistRenderedCount || 0) - 1);
        updateWishlistCounter(-1);
        tile.classList.add('is-wishlist-removing');
        if (tile === activeCard || tile.contains(activeCard)) {
          activeCard = null;
          activePlayButton = null;
        }
        window.setTimeout(() => {
          const list = shell.querySelector('[data-wm-wishlist-list]');
          tile.remove();
          scheduleCartButtonAlignment(shell);
          if (list && list.children.length === 0) {
            list.hidden = true;
            const status = shell.querySelector('[data-wm-wishlist-status]');
            if (status) {
              status.hidden = false;
              status.textContent = 'Your wishlist is empty.';
            }
          }
        }, 190);
      } catch (err) {
        button.disabled = false;
        setTileWishlistState(button, true);
        if (tile === activeCard || tile.contains(activeCard)) setGlobalWishlistState(true);
      }
    }

    async function addTileToCart(button) {
      if (!button || button.disabled) return;
      const originalText = button.dataset.wmCartDefaultText || button.textContent;
      const handle = button.dataset.wmWishlistHandle || button.closest('[data-wm-wishlist-handle]')?.dataset.wmWishlistHandle || '';
      const preferredVariantId = button.dataset.wmWishlistVariantId || button.closest('[data-wm-wishlist-variant-id]')?.dataset.wmWishlistVariantId || '';

      button.disabled = true;
      button.classList.remove('is-added');
      button.textContent = 'Adding...';
      try {
        const variantId = await resolveCartVariantId(handle, preferredVariantId);
        const isPreorder = button.classList.contains('is-preorder');
        const releaseDate = isPreorder ? await resolvePreorderReleaseDate(handle, button) : '';
        await addVariantToCart(
          variantId,
          isPreorder,
          releaseDate
        );
        postRecommendationEvent(handle, 'add_to_cart');
        refreshCartCount();
        button.classList.add('is-added');
        button.textContent = 'Added';
        window.setTimeout(() => {
          button.disabled = false;
          button.classList.remove('is-added');
          button.textContent = originalText || 'ADD TO CART';
        }, 1800);
      } catch (err) {
        button.disabled = false;
        button.textContent = 'Try again';
        window.setTimeout(() => {
          button.textContent = originalText || 'ADD TO CART';
        }, 1800);
      }
    }

    function updateTileButtons(isPlaying) {
      shell.querySelectorAll('.wm-grid-audio-card.is-grid-audio-playing').forEach((card) => {
        if (card !== activeCard) card.classList.remove('is-grid-audio-playing');
      });
      if (activeCard) activeCard.classList.toggle('is-grid-audio-playing', !!isPlaying);
      if (activePlayButton) activePlayButton.setAttribute('aria-label', isPlaying ? 'Pause audio preview' : 'Play audio preview');
    }

    function updatePlayerUi(resetProgress = true) {
      const releaseTitle = String(activeOverlay?.getAttribute('data-wm-grid-audio-title') || 'Preview').trim();
      const trackTitle = String(activeTitles[activeTrackIndex] || `Track ${activeTrackIndex + 1}`).trim();
      const cover = activeOverlay?.getAttribute('data-wm-grid-audio-cover') || '';
      const productUrl = activeOverlay?.getAttribute('data-wm-grid-audio-url') || '#';

      if (releaseEl) releaseEl.textContent = releaseTitle;
      if (trackEl) trackEl.textContent = trackTitle;
      if (productLinkEl) productLinkEl.href = productUrl;
      if (coverEl) {
        coverEl.src = cover;
        coverEl.alt = releaseTitle;
      }
      if (resetProgress) {
        setProgress(0);
        if (currentTimeEl) currentTimeEl.textContent = '0:00';
        if (durationEl) durationEl.textContent = '0:00';
      }
      player.classList.add('is-visible');
      document.body.classList.add('wm-grid-player-open');
      refreshWishlistButtons();
      setTimeout(syncGlobalWishlistFromTile, 350);
      setTimeout(syncGlobalWishlistFromTile, 1200);
    }

    function setActive(overlay, src, trackIndex) {
      if (activeCard && activeCard !== overlay.closest('.wm-grid-audio-card')) {
        activeCard.classList.remove('is-grid-audio-playing');
      }
      if (activePlayButton && activePlayButton !== overlay.querySelector('[data-wm-grid-audio-play]')) {
        activePlayButton.setAttribute('aria-label', 'Play audio preview');
      }
      activeOverlay = overlay;
      activePlayButton = overlay.querySelector('[data-wm-grid-audio-play]');
      activeCard = overlay.closest('.wm-grid-audio-card');
      activeSrc = src;
      activeTrackIndex = trackIndex;
      activeTracks = parseJsonAttribute(overlay, 'data-wm-grid-audio-urls').map((url) => String(url || '').trim()).filter(Boolean);
      activeTitles = parseJsonAttribute(overlay, 'data-wm-grid-audio-titles');
      updatePlayerUi(true);
    }

    async function playOverlay(overlay, trackIndex = 0, toggle = true) {
      const urls = parseJsonAttribute(overlay, 'data-wm-grid-audio-urls').map((url) => String(url || '').trim()).filter(Boolean);
      if (!urls.length) return;
      const safeTrackIndex = Math.max(0, Math.min(urls.length - 1, Number(trackIndex) || 0));
      const src = urls[safeTrackIndex];
      const sameTrack = activeOverlay === overlay && activeSrc === src;
      if (toggle && sameTrack && !audio.paused) {
        audio.pause();
        updateTileButtons(false);
        return;
      }
      if (!sameTrack || audio.src !== src) {
        audio.pause();
        audio.removeAttribute('src');
        audio.src = src;
        audio.load();
      }
      setActive(overlay, src, safeTrackIndex);
      try {
        await audio.play();
      } catch (err) {
        updateTileButtons(false);
      }
    }

    async function playActiveTrack(trackIndex, toggle = false) {
      if (!activeOverlay || !activeTracks.length) return;
      const safeTrackIndex = Math.max(0, Math.min(activeTracks.length - 1, Number(trackIndex) || 0));
      const src = activeTracks[safeTrackIndex];
      const sameTrack = activeSrc === src;
      if (toggle && sameTrack && !audio.paused) {
        audio.pause();
        updateTileButtons(false);
        return;
      }
      activeTrackIndex = safeTrackIndex;
      activeSrc = src;
      updatePlayerUi(!sameTrack);
      if (!sameTrack || audio.src !== src) {
        audio.pause();
        audio.removeAttribute('src');
        audio.src = src;
        audio.load();
      }
      try {
        await audio.play();
      } catch (err) {
        updateTileButtons(false);
      }
    }

    function adjacentProductOverlay(direction = 1) {
      if (!activeCard) return null;
      const cards = Array.from(shell.querySelectorAll('.wm-grid-audio-card'));
      const currentIndex = cards.indexOf(activeCard);
      if (currentIndex === -1) return null;
      const step = direction >= 0 ? 1 : -1;
      for (let index = currentIndex + step; index >= 0 && index < cards.length; index += step) {
        const overlay = cards[index].querySelector('[data-wm-grid-audio]');
        const urls = overlay ? parseJsonAttribute(overlay, 'data-wm-grid-audio-urls').filter(Boolean) : [];
        if (overlay && urls.length) return overlay;
      }
      return null;
    }

    function playAdjacentProduct(direction = 1) {
      const overlay = adjacentProductOverlay(direction);
      if (!overlay) return;
      const urls = parseJsonAttribute(overlay, 'data-wm-grid-audio-urls').filter(Boolean);
      playOverlay(overlay, direction >= 0 ? 0 : Math.max(0, urls.length - 1), false);
    }

    function changeTrack(direction) {
      if (!activeTracks.length) return;
      if (direction > 0 && activeTrackIndex >= activeTracks.length - 1) {
        playAdjacentProduct(1);
        return;
      }
      if (direction < 0 && activeTrackIndex <= 0) {
        playAdjacentProduct(-1);
        return;
      }
      playActiveTrack(activeTrackIndex + direction, false);
    }

    function dismissPlayer() {
      audio.pause();
      audio.removeAttribute('src');
      audio.load();
      if (activeCard) activeCard.classList.remove('is-grid-audio-playing');
      activeOverlay = null;
      activeCard = null;
      activePlayButton = null;
      activeTracks = [];
      activeTitles = [];
      activeTrackIndex = 0;
      activeSrc = '';
      player.classList.remove('is-visible', 'is-playing');
      document.body.classList.remove('wm-grid-player-open');
    }

    function seekFromClientX(clientX) {
      if (!progressEl || !audio.duration) return;
      const rect = progressEl.getBoundingClientRect();
      if (!rect.width) return;
      const percent = Math.max(0, Math.min(1, (clientX - rect.left) / rect.width));
      audio.currentTime = percent * audio.duration;
      setProgress(percent * 100);
    }

    function seekFromEvent(event) {
      const clientX = event.clientX ?? (event.touches && event.touches[0] ? event.touches[0].clientX : null);
      if (clientX === null) return;
      seekFromClientX(clientX);
    }

    function audioListenKey(handle) {
      return [
        handle || '',
        audio.currentSrc || audio.src || activeSrc || ''
      ].join('|');
    }

    function trackAudioProgress() {
      const handle = activeCard?.dataset?.wmWishlistHandle ||
        activeCard?.dataset?.productHandle ||
        activeOverlay?.getAttribute('data-wm-grid-audio-product') ||
        '';
      const duration = Number(audio.duration || 0);
      const currentTime = Number(audio.currentTime || 0);
      if (!handle || duration <= 0 || currentTime <= 0) return;

      const key = audioListenKey(handle);
      const progress = audio.__wmWishlistGridListenProgress || (audio.__wmWishlistGridListenProgress = {});
      const state = progress[key] || {
        listenedSeconds: 0,
        lastCurrentTime: currentTime,
        lastUpdatedAt: Date.now()
      };
      const now = Date.now();
      const mediaDelta = currentTime - Number(state.lastCurrentTime || 0);
      const wallDelta = (now - Number(state.lastUpdatedAt || now)) / 1000;

      if (
        !audio.paused &&
        mediaDelta > 0 &&
        mediaDelta <= 2.5 &&
        wallDelta > 0 &&
        wallDelta <= 3
      ) {
        state.listenedSeconds += Math.min(mediaDelta, wallDelta + 0.5);
      }

      state.lastCurrentTime = currentTime;
      state.lastUpdatedAt = now;
      progress[key] = state;

      const percent = Math.floor((state.listenedSeconds / duration) * 100);
      const sent = audio.__wmWishlistGridListenSent || (audio.__wmWishlistGridListenSent = {});
      sent[key] = sent[key] || {};

      [10, 25, 50, 80].forEach((threshold) => {
        if (percent < threshold || sent[key][threshold]) return;
        sent[key][threshold] = true;
        postRecommendationEvent(handle, 'audio_listen_' + threshold, {
          listen_percent: threshold,
          listen_seconds: Math.round(state.listenedSeconds),
          duration_seconds: Math.round(duration)
        });
      });
    }

    shell.addEventListener('click', (event) => {
      const productLink = event.target.closest('a[href*="/products/"]');
      if (
        productLink &&
        shell.contains(productLink) &&
        !event.target.closest('[data-wm-grid-audio], .wm-wishlist-cart-button, .wm-wishlist-remove-button, .wm-grid-swish-anchor')
      ) {
        const tile = productLink.closest('.wm-index-grid__item, [data-product-handle], [data-wm-wishlist-handle]');
        const handle = tile?.dataset?.wmWishlistHandle || tile?.dataset?.productHandle || '';
        postRecommendationEvent(handle, 'product_click');
      }

      const overlay = event.target.closest('[data-wm-grid-audio]');
      if (!overlay || !shell.contains(overlay)) return;
      event.preventDefault();
      event.stopPropagation();
      playOverlay(overlay, activeOverlay === overlay ? activeTrackIndex : 0, true);
    }, true);

    shell.addEventListener('click', (event) => {
      const cartButton = event.target.closest('.wm-wishlist-cart-button');
      if (cartButton && shell.contains(cartButton)) {
        event.preventDefault();
        event.stopPropagation();
        addTileToCart(cartButton);
        return;
      }

      const removeButton = event.target.closest('.wm-wishlist-remove-button');
      if (removeButton && shell.contains(removeButton)) {
        event.preventDefault();
        event.stopPropagation();
        removeTileFromWishlist(removeButton);
        return;
      }

      const button = event.target.closest('.wm-grid-swish-anchor .wk-button');
      if (!button || !shell.contains(button) || !event.isTrusted) return;
      const card = button.closest('.wm-grid-audio-card');
      const isActive = !wishlistButtonIsActive(button);
      button.dataset.wmWishlistGridTouched = '1';
      setTileWishlistState(button, isActive);
      if (card && activeCard === card) setGlobalWishlistState(isActive);
      setTimeout(syncGlobalWishlistFromTile, 500);
      setTimeout(syncGlobalWishlistFromTile, 1600);
    }, true);

    wishlistButton?.addEventListener('click', (event) => {
      event.preventDefault();
      const tileButton = activeTileWishlistButton();
      if (!tileButton) {
        refreshWishlistButtons();
        setTimeout(() => activeTileWishlistButton()?.click(), 500);
        return;
      }
      if (tileButton.classList.contains('wm-wishlist-remove-button')) {
        removeTileFromWishlist(tileButton);
        return;
      }
      const isActive = !wishlistButtonIsActive(tileButton);
      tileButton.dataset.wmWishlistGridTouched = '1';
      setTileWishlistState(tileButton, isActive);
      setGlobalWishlistState(isActive);
      tileButton.click();
      setTimeout(syncGlobalWishlistFromTile, 500);
      setTimeout(syncGlobalWishlistFromTile, 1600);
    });

    playButton?.addEventListener('click', () => playActiveTrack(activeTrackIndex, true));
    prevButton?.addEventListener('click', () => changeTrack(-1));
    nextButton?.addEventListener('click', () => changeTrack(1));
    progressEl?.addEventListener('click', seekFromEvent);
    progressEl?.addEventListener('pointerdown', (event) => {
      if (!audio.duration) return;
      progressDragActive = true;
      progressEl.setPointerCapture?.(event.pointerId);
      seekFromClientX(event.clientX);
      event.preventDefault();
    });
    progressEl?.addEventListener('pointermove', (event) => {
      if (!progressDragActive) return;
      seekFromClientX(event.clientX);
      event.preventDefault();
    });
    progressEl?.addEventListener('pointerup', (event) => {
      if (!progressDragActive) return;
      progressDragActive = false;
      progressEl.releasePointerCapture?.(event.pointerId);
      event.preventDefault();
    });
    progressEl?.addEventListener('pointercancel', () => {
      progressDragActive = false;
    });
    shell.addEventListener('load', (event) => {
      if (event.target && event.target.tagName === 'IMG') scheduleCartButtonAlignment(shell);
    }, true);
    window.addEventListener('resize', () => scheduleCartButtonAlignment(shell));
    player.addEventListener('touchstart', (event) => {
      if (event.target.closest('[data-wm-grid-player-progress]')) return;
      const touch = event.touches && event.touches[0];
      if (!touch) return;
      playerSwipeStartX = touch.clientX;
      playerSwipeStartY = touch.clientY;
      playerSwipeStartTime = Date.now();
    }, { passive: true });
    player.addEventListener('touchend', (event) => {
      const touch = event.changedTouches && event.changedTouches[0];
      if (!touch) return;
      const deltaX = touch.clientX - playerSwipeStartX;
      const deltaY = touch.clientY - playerSwipeStartY;
      const elapsed = Date.now() - playerSwipeStartTime;
      if (elapsed > 900) return;
      if (deltaY > 54 && Math.abs(deltaY) > Math.abs(deltaX) * 1.25) {
        event.preventDefault();
        dismissPlayer();
      }
    }, { passive: false });

    audio.addEventListener('pause', () => {
      player.classList.remove('is-playing');
      playButton?.setAttribute('aria-label', 'Play');
      updateTileButtons(false);
    });
    audio.addEventListener('play', () => {
      player.classList.add('is-playing', 'is-visible');
      playButton?.setAttribute('aria-label', 'Pause');
      document.body.classList.add('wm-grid-player-open');
      updateTileButtons(true);
    });
    audio.addEventListener('loadedmetadata', () => {
      audio.__wmWishlistGridListenSent = {};
      audio.__wmWishlistGridListenProgress = {};
      if (durationEl) durationEl.textContent = formatTime(audio.duration);
    });
    audio.addEventListener('timeupdate', () => {
      if (currentTimeEl) currentTimeEl.textContent = formatTime(audio.currentTime);
      if (audio.duration) setProgress((audio.currentTime / audio.duration) * 100);
      trackAudioProgress();
    });
    audio.addEventListener('ended', () => {
      if (activeTracks.length && activeTrackIndex < activeTracks.length - 1) {
        playActiveTrack(activeTrackIndex + 1, false);
      } else {
        playAdjacentProduct(1);
      }
    });
    function stopAudioForPageExit() {
      audio.pause();
      updateTileButtons(false);
      player.classList.remove('is-playing');
    }
    window.addEventListener('pagehide', stopAudioForPageExit);
    window.addEventListener('beforeunload', stopAudioForPageExit);
    document.addEventListener('visibilitychange', () => {
      if (document.visibilityState === 'hidden') stopAudioForPageExit();
    });
    document.addEventListener('freeze', stopAudioForPageExit);
  }

  async function boot() {
    const isAuthenticated = await wmWishlistCustomerIsAuthenticated();
    if (!isAuthenticated) {
      redirectToWishlistLogin();
      return;
    }
    document.documentElement.classList.remove('wm-wishlist-auth-pending');

    document.documentElement.classList.add(GRID_CLASS);
    installStyles();
    styleWishlistFooter();
    setTimeout(styleWishlistFooter, 500);
    setTimeout(styleWishlistFooter, 1500);

    const defaultPage = await waitFor(() => document.querySelector('wishlist-page'), 10000);
    const api = await waitFor(() => wishlistApi()?.loadWishlist && wishlistApi(), 12000);
    const shell = buildShell(defaultPage);
    const status = shell.querySelector('[data-wm-wishlist-status]');

    if (!api) {
      status.textContent = 'Wishlist could not be loaded.';
      return;
    }

    let items = [];
    try {
      items = await loadWishlistItems();
    } catch (err) {
      status.textContent = 'Wishlist could not be loaded.';
      return;
    }

    const uniqueByKey = new Map();
    items.forEach((item) => {
      const key = wishlistItemKey(item);
      if (key && !uniqueByKey.has(key)) uniqueByKey.set(key, item);
    });
    const uniqueItems = Array.from(uniqueByKey.values());

    if (!uniqueItems.length) {
      status.textContent = 'Your wishlist is empty.';
      return;
    }

    const initialSort = 'created-descending';
    const initialItems = await sortWishlistItems(uniqueItems, initialSort).catch(() => uniqueItems);
    shell.__wmWishlistItems = uniqueItems;
    shell.__wmWishlistSortedItems = initialItems;
    shell.__wmWishlistActiveSort = 'created-descending';

    let renderedCount = 0;
    try {
      renderedCount = await renderTiles(shell, initialItems, 0);
      shell.__wmWishlistRenderedCount = renderedCount;
    } catch (err) {
      status.textContent = 'Wishlist products could not be loaded.';
      return;
    }

    status.hidden = true;
    const infinite = installWishlistInfiniteScroll(shell);
    infinite?.update();
    infinite?.scheduleCheck();
    document.documentElement.classList.add(GRID_READY_CLASS);
    installGridPlayer(shell);
    scheduleCartButtonAlignment(shell);
    setTimeout(() => scheduleCartButtonAlignment(shell), 350);
    setTimeout(() => scheduleCartButtonAlignment(shell), 1200);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }
})();
